import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  IntOrIntArray: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AddEstimationInput = {
  estimatedTimes: Array<EstimatedTimeInput>;
  projectId: Scalars['String']['input'];
};

export type AddRolesInput = {
  id: Scalars['ID']['input'];
  roles: Array<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export enum AnalysisLevel {
  Basic = 'BASIC',
  Enterprise = 'ENTERPRISE',
  Professional = 'PROFESSIONAL'
}

export type Audit = {
  __typename?: 'Audit';
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  metadata: AuditMetadata;
  type: Scalars['String']['output'];
};

export type AuditCompareResult = {
  __typename?: 'AuditCompareResult';
  auditId: Scalars['ID']['output'];
  changes?: Maybe<Scalars['JSON']['output']>;
  comparedWith: Scalars['String']['output'];
  previousAuditId?: Maybe<Scalars['ID']['output']>;
  resourceId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type AuditMetadata = {
  __typename?: 'AuditMetadata';
  createdAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ChangeOwnPasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type Comment = {
  __typename?: 'Comment';
  action?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  comment: Scalars['String']['output'];
  forward?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['String']['output'];
  metadata: Metadata;
  parentCommentId?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  replies?: Maybe<Array<Scalars['String']['output']>>;
  replyToAll?: Maybe<Scalars['Boolean']['output']>;
  service_name: Scalars['String']['output'];
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetUsers?: Maybe<Array<Scalars['String']['output']>>;
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type CommentPage = {
  __typename?: 'CommentPage';
  items: Array<RecentComment>;
  stages: Array<RecentCommentStage>;
  total: Scalars['Int']['output'];
};

export type Company = {
  __typename?: 'Company';
  address?: Maybe<Address>;
  businessType?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  contactPerson: ContactPerson;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  ownerId: Scalars['String']['output'];
  state: CompanyState;
  updatedAt: Scalars['DateTime']['output'];
  userIds?: Maybe<Array<Scalars['String']['output']>>;
  website?: Maybe<Scalars['String']['output']>;
};

export enum CompanyState {
  Active = 'active',
  Locked = 'locked',
  Pending = 'pending',
  Suspended = 'suspended'
}

export type ConfirmResetPasswordInput = {
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
  resetPasswordCode: Scalars['String']['input'];
};

export type ContactMessage = {
  __typename?: 'ContactMessage';
  captchaResponse?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<GuestContactMetadata>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  read?: Maybe<ContactMessageRead>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContactMessageRead = {
  __typename?: 'ContactMessageRead';
  readDate?: Maybe<Scalars['DateTime']['output']>;
  readUser?: Maybe<Scalars['String']['output']>;
};

export type ContactMessagesResponse = {
  __typename?: 'ContactMessagesResponse';
  messages: Array<ContactMessage>;
  pagination: Pagination;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  position: Scalars['String']['output'];
};

export type ContactPersonInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  position: Scalars['String']['input'];
};

export type CreateCommentInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  comment: Scalars['String']['input'];
  index: Scalars['String']['input'];
  parentCommentId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  service_name: Scalars['String']['input'];
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  targetUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateCompanyInput = {
  address?: InputMaybe<AddressInput>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  contactPerson: ContactPersonInput;
  email: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyResponse = {
  __typename?: 'CreateCompanyResponse';
  message: Scalars['String']['output'];
};

export type CreateProjectInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  data?: InputMaybe<Array<StateDataItemInput>>;
  description: Scalars['String']['input'];
  service?: InputMaybe<ProjectServiceItemInput>;
  timeline?: InputMaybe<ProjectTimelineInput>;
  title: Scalars['String']['input'];
};

export type CreateReplyInput = {
  comment: Scalars['String']['input'];
  parentCommentId: Scalars['ID']['input'];
  replyToAll: Scalars['Boolean']['input'];
};

export type CreateSalesRequestInput = {
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientName: Scalars['String']['input'];
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  contractDocuments?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedDataType?: InputMaybe<Scalars['String']['input']>;
  quotationAmount?: InputMaybe<Scalars['Float']['input']>;
  requestedServices: Array<Scalars['String']['input']>;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  profile: ProfileInput;
  roles?: InputMaybe<Array<Role>>;
  state?: InputMaybe<UserState>;
};

export enum DataSource {
  DroneCapture = 'DRONE_CAPTURE',
  UploadImages = 'UPLOAD_IMAGES'
}

export type DeleteFileResponse = {
  __typename?: 'DeleteFileResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum DeliverableCategory {
  ContourLines = 'CONTOUR_LINES',
  ElevationModel = 'ELEVATION_MODEL',
  Orthomosaic = 'ORTHOMOSAIC',
  PointCloud = 'POINT_CLOUD',
  TexturedMesh = 'TEXTURED_MESH'
}

export enum DeliverableOption {
  ClassifiedPointCloud = 'CLASSIFIED_POINT_CLOUD',
  ContourLines = 'CONTOUR_LINES',
  Dsm = 'DSM',
  Dtm = 'DTM',
  OrthomosaicDtm = 'ORTHOMOSAIC_DTM',
  StandardPointCloud = 'STANDARD_POINT_CLOUD',
  Textured_3DMesh = 'TEXTURED_3D_MESH',
  TrueOrthomosaicDsm = 'TRUE_ORTHOMOSAIC_DSM'
}

export type EstimatedStageTime = {
  __typename?: 'EstimatedStageTime';
  addedBy?: Maybe<Scalars['String']['output']>;
  unit: TimeUnit;
  value: Scalars['Float']['output'];
};

export type EstimatedTime = {
  __typename?: 'EstimatedTime';
  unit: TimeUnit;
  value: Scalars['Float']['output'];
};

export type EstimatedTimeInput = {
  stage: Scalars['Int']['input'];
  unit: TimeUnit;
  value: Scalars['Float']['input'];
};

export type File = {
  __typename?: 'File';
  /**
   * Free-form file flags.
   * - `"s"`       → system/hidden file. Excluded from normal Files listings.
   * - `"comment"` → file uploaded from a comment. Still listed in Files, shown
   *                 with the "From comment" badge.
   */
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  /** Why a NEW upload's import failed, or null. */
  geojson_import_error?: Maybe<Scalars['String']['output']>;
  /**
   * Import lifecycle for NEW boundary uploads: pending | completed | failed.
   * null/absent means a LEGACY file that is read inline.
   */
  geojson_import_status?: Maybe<Scalars['String']['output']>;
  /**
   * PostGIS table backing this file (set once geojson-service finishes importing).
   * When present, the file is rendered from vector tiles, never inline.
   */
  geojson_table?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  metadata?: Maybe<FileMetadata>;
  name: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  physical_name: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
  size: Scalars['Float']['output'];
  state?: Maybe<Scalars['Int']['output']>;
  status: FileStatus;
  type: Scalars['String']['output'];
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum FileStatus {
  Active = 'active',
  Deleted = 'deleted',
  Pending = 'pending'
}

export type FileUpdate = {
  __typename?: 'FileUpdate';
  fileId: Scalars['ID']['output'];
};

export type FilesResponse = {
  __typename?: 'FilesResponse';
  files: Array<File>;
  pagination: Pagination;
};

export type ForwardCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['ID']['input'];
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  targetUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum GcpSource {
  /** @deprecated Use MADAR_AERO_GCP. Kept for existing projects. */
  AeromapGcp = 'AEROMAP_GCP',
  ClientGcp = 'CLIENT_GCP',
  MadarAeroGcp = 'MADAR_AERO_GCP'
}

export type GcpUpload = {
  __typename?: 'GcpUpload';
  coordinateSystem?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  pointCount?: Maybe<Scalars['Int']['output']>;
};

export type GcpUploadInput = {
  coordinateSystem?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  pointCount?: InputMaybe<Scalars['Int']['input']>;
};

export type GeoJsonFeature = {
  __typename?: 'GeoJSONFeature';
  geometry: GeoJsonGeometry;
  properties?: Maybe<GeoJsonProperties>;
  type: Scalars['String']['output'];
};

export type GeoJsonFeatureInput = {
  geometry: GeoJsonGeometryInput;
  properties?: InputMaybe<GeoJsonPropertiesInput>;
  type: Scalars['String']['input'];
};

export type GeoJsonGeometry = {
  __typename?: 'GeoJSONGeometry';
  coordinates: Scalars['JSON']['output'];
  type: Scalars['String']['output'];
};

export type GeoJsonGeometryInput = {
  coordinates: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type GeoJsonProperties = {
  __typename?: 'GeoJSONProperties';
  fileId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GeoJsonPropertiesInput = {
  fileId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum GsdAccuracyProfile {
  HighPrecision = 'HIGH_PRECISION',
  Standard = 'STANDARD',
  SurveyGrade = 'SURVEY_GRADE'
}

export type GuestContactMetadata = {
  __typename?: 'GuestContactMetadata';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ImageUpload = {
  __typename?: 'ImageUpload';
  numberOfImages?: Maybe<Scalars['Int']['output']>;
};

export type ImageUploadInput = {
  numberOfImages?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginInput = {
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarkAsReadInput = {
  messageId: Scalars['String']['input'];
};

export type Metadata = {
  __typename?: 'Metadata';
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum MountingType {
  Fixed = 'FIXED',
  Tracker = 'TRACKER'
}

export type Mutation = {
  __typename?: 'Mutation';
  addEstimationForOtherStage: Project;
  addRoles?: Maybe<User>;
  changeOwnPassword: Scalars['Boolean']['output'];
  changePassword?: Maybe<User>;
  createComment: Comment;
  createCompany: CreateCompanyResponse;
  createProject: Project;
  createSalesRequest: SalesRequest;
  createUser: User;
  deleteFile: DeleteFileResponse;
  deleteProject: DeleteResponse;
  executeWorkflowAction: Project;
  forwardComment: Comment;
  login?: Maybe<LoginResponse>;
  logout?: Maybe<LogoutResponse>;
  markContactMessageAsRead: ContactMessage;
  registerUserWithCompany: RegistrationResult;
  replaceSetting: Setting;
  replyToComment: Comment;
  requestResetPassword: Scalars['String']['output'];
  restrictCommentVisibility: Comment;
  reviewSalesRequest: ReviewResult;
  sendContactMessage: ContactMessage;
  setNotificationSeen: Notification;
  setWorkflowState: Project;
  updateCompany: Company;
  updateCompanyState: Company;
  updateProject: Project;
  updateProjectAssignedTo: Project;
  updateProjectStatus: Project;
  updateSalesRequest: SalesRequest;
  updateSetting: Setting;
  updateUser: User;
  userOperation?: Maybe<User>;
  verifyEmail?: Maybe<VerifyEmailResponse>;
};


export type MutationAddEstimationForOtherStageArgs = {
  input: AddEstimationInput;
};


export type MutationAddRolesArgs = {
  input: AddRolesInput;
};


export type MutationChangeOwnPasswordArgs = {
  input: ChangeOwnPasswordInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateSalesRequestArgs = {
  input: CreateSalesRequestInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExecuteWorkflowActionArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationForwardCommentArgs = {
  input: ForwardCommentInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMarkContactMessageAsReadArgs = {
  input: MarkAsReadInput;
};


export type MutationRegisterUserWithCompanyArgs = {
  input: RegisterUserWithCompanyInput;
};


export type MutationReplaceSettingArgs = {
  input: SettingUpdateInput;
  key: Scalars['String']['input'];
};


export type MutationReplyToCommentArgs = {
  input: CreateReplyInput;
};


export type MutationRequestResetPasswordArgs = {
  input: RequestResetPasswordInput;
};


export type MutationRestrictCommentVisibilityArgs = {
  input: RestrictCommentInput;
};


export type MutationReviewSalesRequestArgs = {
  action: ReviewAction;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendContactMessageArgs = {
  input: SendContactMessageInput;
};


export type MutationSetNotificationSeenArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationSetWorkflowStateArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyStateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompanyStateInput;
};


export type MutationUpdateProjectArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProjectInput;
};


export type MutationUpdateProjectAssignedToArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateProjectStatusArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProjectStatusInput;
};


export type MutationUpdateSalesRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSalesRequestInput;
};


export type MutationUpdateSettingArgs = {
  input: SettingUpdateInput;
  key: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  _id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationUserOperationArgs = {
  id: Scalars['ID']['input'];
  operation: Scalars['String']['input'];
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};

export type Notification = {
  __typename?: 'Notification';
  body: Scalars['String']['output'];
  every_one: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<NotificationMetadata>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  seen?: Maybe<Array<Scalars['String']['output']>>;
  seenTimeToLive?: Maybe<Scalars['Int']['output']>;
  timeToLive?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  users?: Maybe<Array<Scalars['String']['output']>>;
};

export type NotificationItem = {
  __typename?: 'NotificationItem';
  body: Scalars['String']['output'];
  every_one: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<NotificationMetadata>;
  seen?: Maybe<Array<Scalars['String']['output']>>;
  seenTimeToLive?: Maybe<Scalars['Int']['output']>;
  timeToLive?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type NotificationMetadata = {
  __typename?: 'NotificationMetadata';
  createdAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type NotificationPage = {
  __typename?: 'NotificationPage';
  items: Array<Notification>;
  total: Scalars['Int']['output'];
};

export enum OutputFormat {
  Bpc = 'BPC',
  Dwg = 'DWG',
  Dxf = 'DXF',
  Fbx = 'FBX',
  Jpg = 'JPG',
  Las = 'LAS',
  Las_1_2 = 'LAS_1_2',
  Laz = 'LAZ',
  Obj = 'OBJ',
  Ply = 'PLY',
  Shp = 'SHP',
  Slpk = 'SLPK',
  Tiff = 'TIFF',
  Xyz = 'XYZ'
}

export type Pagination = {
  __typename?: 'Pagination';
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  maxLimit: Scalars['Int']['output'];
  order?: Maybe<Scalars['String']['output']>;
  page: Scalars['Int']['output'];
  sort?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export enum PanelType {
  HalfCut = 'HALF_CUT',
  Standard = 'STANDARD'
}

export enum PlantType {
  Floating = 'FLOATING',
  GroundMounted = 'GROUND_MOUNTED',
  Residential = 'RESIDENTIAL',
  Rooftop = 'ROOFTOP'
}

export enum PotentialRisk {
  AirspaceRestrictions = 'AIRSPACE_RESTRICTIONS',
  OperationalSafety = 'OPERATIONAL_SAFETY',
  PowerLineInterference = 'POWER_LINE_INTERFERENCE',
  SiteAccessibility = 'SITE_ACCESSIBILITY',
  WeatherDependencies = 'WEATHER_DEPENDENCIES',
  WildlifeEnvironmental = 'WILDLIFE_ENVIRONMENTAL'
}

export type Profile = {
  __typename?: 'Profile';
  additionalData?: Maybe<Scalars['JSON']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type ProfileInput = {
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type Project = {
  __typename?: 'Project';
  assignedTo?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  data?: Maybe<Array<StateDataItem>>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  metadata?: Maybe<ProjectMetadata>;
  ownerId?: Maybe<Scalars['String']['output']>;
  priorityRank?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  service?: Maybe<ProjectServiceItem>;
  status: ProjectStatus;
  timeline?: Maybe<ProjectTimeline>;
  title: Scalars['String']['output'];
};

export enum ProjectAssignment {
  Assigned = 'assigned',
  Unassigned = 'unassigned'
}

/**
 * Emitted whenever a project's assignedTo value changes.
 * Subscribers re-read the project lists with their own permissions.
 */
export type ProjectAssignmentUpdate = {
  __typename?: 'ProjectAssignmentUpdate';
  changedAt: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
};

export type ProjectDeliverable = {
  __typename?: 'ProjectDeliverable';
  category?: Maybe<DeliverableCategory>;
  options: Array<DeliverableOption>;
  outputFormats: Array<OutputFormat>;
};

export type ProjectDeliverableInput = {
  category: DeliverableCategory;
  options: Array<DeliverableOption>;
  outputFormats: Array<OutputFormat>;
};

export type ProjectInspection = {
  __typename?: 'ProjectInspection';
  analysisLevel?: Maybe<AnalysisLevel>;
  dataSource?: Maybe<DataSource>;
  deliverables?: Maybe<Array<ProjectDeliverable>>;
  flightAltitude?: Maybe<Scalars['String']['output']>;
  gcpSource?: Maybe<GcpSource>;
  gcpUpload?: Maybe<GcpUpload>;
  gsd?: Maybe<Scalars['String']['output']>;
  gsdAccuracyProfile?: Maybe<GsdAccuracyProfile>;
  imageUpload?: Maybe<ImageUpload>;
  missionDesign?: Maybe<ProjectInspectionMission>;
  module?: Maybe<ProjectInspectionModule>;
  plant?: Maybe<ProjectInspectionPlant>;
  potentialRisks?: Maybe<Array<PotentialRisk>>;
  pricingProposal?: Maybe<ProjectPricingProposal>;
  priority?: Maybe<ProjectPriority>;
  sensor?: Maybe<Array<SensorPayload>>;
  technicalMetrics?: Maybe<TechnicalMetrics>;
  technicalQualityChecklist?: Maybe<ProjectInspectionTechnicalQualityChecklist>;
};

export type ProjectInspectionInput = {
  analysisLevel?: InputMaybe<AnalysisLevel>;
  dataSource?: InputMaybe<DataSource>;
  deliverables?: InputMaybe<Array<ProjectDeliverableInput>>;
  flightAltitude?: InputMaybe<Scalars['String']['input']>;
  gcpSource?: InputMaybe<GcpSource>;
  gcpUpload?: InputMaybe<GcpUploadInput>;
  gsd?: InputMaybe<Scalars['String']['input']>;
  gsdAccuracyProfile?: InputMaybe<GsdAccuracyProfile>;
  imageUpload?: InputMaybe<ImageUploadInput>;
  missionDesign?: InputMaybe<ProjectInspectionMissionInput>;
  module?: InputMaybe<ProjectInspectionModuleInput>;
  plant?: InputMaybe<ProjectInspectionPlantInput>;
  potentialRisks?: InputMaybe<Array<PotentialRisk>>;
  pricingProposal?: InputMaybe<ProjectPricingProposalInput>;
  priority?: InputMaybe<ProjectPriority>;
  sensor?: InputMaybe<Array<SensorPayload>>;
  technicalMetrics?: InputMaybe<TechnicalMetricsInput>;
  technicalQualityChecklist?: InputMaybe<ProjectInspectionTechnicalQualityChecklistInput>;
};

export type ProjectInspectionMission = {
  __typename?: 'ProjectInspectionMission';
  coverageAreaHectares?: Maybe<Scalars['String']['output']>;
  estimatedFlightTimeHours?: Maybe<Scalars['String']['output']>;
  flightDate?: Maybe<Scalars['DateTime']['output']>;
  flightDurationMinutes?: Maybe<Scalars['Int']['output']>;
  forwardOverlapPercent?: Maybe<Scalars['Int']['output']>;
  imageCount?: Maybe<Scalars['Int']['output']>;
  numberOfMissions?: Maybe<Scalars['String']['output']>;
  sideOverlapPercent?: Maybe<Scalars['Int']['output']>;
  weatherConditions?: Maybe<Scalars['String']['output']>;
};

export type ProjectInspectionMissionInput = {
  coverageAreaHectares?: InputMaybe<Scalars['String']['input']>;
  estimatedFlightTimeHours?: InputMaybe<Scalars['String']['input']>;
  flightDate?: InputMaybe<Scalars['DateTime']['input']>;
  flightDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  forwardOverlapPercent?: InputMaybe<Scalars['Int']['input']>;
  imageCount?: InputMaybe<Scalars['Int']['input']>;
  numberOfMissions?: InputMaybe<Scalars['String']['input']>;
  sideOverlapPercent?: InputMaybe<Scalars['Int']['input']>;
  weatherConditions?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectInspectionModule = {
  __typename?: 'ProjectInspectionModule';
  height?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  panelType?: Maybe<PanelType>;
  width?: Maybe<Scalars['String']['output']>;
};

export type ProjectInspectionModuleInput = {
  height?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  panelType?: InputMaybe<PanelType>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectInspectionPlant = {
  __typename?: 'ProjectInspectionPlant';
  installedCapacityMW?: Maybe<Scalars['Float']['output']>;
  mountingType?: Maybe<MountingType>;
  plantType?: Maybe<PlantType>;
};

export type ProjectInspectionPlantInput = {
  installedCapacityMW?: InputMaybe<Scalars['Float']['input']>;
  mountingType?: InputMaybe<MountingType>;
  plantType?: InputMaybe<PlantType>;
};

export type ProjectInspectionTechnicalQualityChecklist = {
  __typename?: 'ProjectInspectionTechnicalQualityChecklist';
  completeSiteCoverageVerified?: Maybe<Scalars['Boolean']['output']>;
  fileFormatCompatibilityConfirmed?: Maybe<Scalars['Boolean']['output']>;
  imageResolutionMet?: Maybe<Scalars['Boolean']['output']>;
  metadataGeolocationValid?: Maybe<Scalars['Boolean']['output']>;
  noMissingOrCorruptedFiles?: Maybe<Scalars['Boolean']['output']>;
  thermalCalibrationDataPresent?: Maybe<Scalars['Boolean']['output']>;
};

export type ProjectInspectionTechnicalQualityChecklistInput = {
  completeSiteCoverageVerified?: InputMaybe<Scalars['Boolean']['input']>;
  fileFormatCompatibilityConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  imageResolutionMet?: InputMaybe<Scalars['Boolean']['input']>;
  metadataGeolocationValid?: InputMaybe<Scalars['Boolean']['input']>;
  noMissingOrCorruptedFiles?: InputMaybe<Scalars['Boolean']['input']>;
  thermalCalibrationDataPresent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectMetadata = {
  __typename?: 'ProjectMetadata';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectPricingProposal = {
  __typename?: 'ProjectPricingProposal';
  currency?: Maybe<Scalars['String']['output']>;
  proposedPrice?: Maybe<Scalars['String']['output']>;
};

export type ProjectPricingProposalInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  proposedPrice?: InputMaybe<Scalars['String']['input']>;
};

export enum ProjectPriority {
  High = 'high',
  Normal = 'normal',
  Urgent = 'urgent'
}

export type ProjectServiceItem = {
  __typename?: 'ProjectServiceItem';
  current_state?: Maybe<Scalars['Int']['output']>;
  current_state_started_at?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  prev_state?: Maybe<Scalars['Int']['output']>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  serviceId: Scalars['String']['output'];
  serviceName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  workflow_version?: Maybe<Scalars['Int']['output']>;
};

export type ProjectServiceItemInput = {
  inspection?: InputMaybe<ProjectInspectionInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  serviceId: Scalars['String']['input'];
  serviceName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum ProjectStatus {
  Active = 'active',
  AdminApproved = 'admin_approved',
  Analysis = 'analysis',
  Archived = 'archived',
  Cancelled = 'cancelled',
  Completed = 'completed',
  DataCollection = 'data_collection',
  Delivered = 'delivered',
  InProgress = 'in_progress',
  OnHold = 'on_hold',
  Paused = 'paused',
  PendingAdminReview = 'pending_admin_review',
  Processing = 'processing',
  QualityReview = 'quality_review',
  Rejected = 'rejected',
  SalesRequested = 'sales_requested'
}

export type ProjectStatusCount = {
  __typename?: 'ProjectStatusCount';
  count: Scalars['Int']['output'];
  status: ProjectStatus;
};

export type ProjectStatusCounts = {
  __typename?: 'ProjectStatusCounts';
  counts: Array<ProjectStatusCount>;
  total: Scalars['Int']['output'];
};

export type ProjectTimeline = {
  __typename?: 'ProjectTimeline';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  estimatedDuration?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectTimelineInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedDuration?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectsResponse = {
  __typename?: 'ProjectsResponse';
  pagination: Pagination;
  projects: Array<Project>;
};

export type Query = {
  __typename?: 'Query';
  allAudits: Array<Audit>;
  allComments: Array<Comment>;
  allCompanies?: Maybe<Array<Company>>;
  allContactMessages: ContactMessagesResponse;
  allFiles: FilesResponse;
  allProjects: ProjectsResponse;
  allServices: Array<Service>;
  allSettings?: Maybe<Array<Maybe<Setting>>>;
  allUsers?: Maybe<Array<Maybe<User>>>;
  auditById?: Maybe<Audit>;
  auditDifferences: Array<Audit>;
  companiesByOwnerId?: Maybe<Array<Company>>;
  companyByEmail?: Maybe<Company>;
  companyById?: Maybe<Company>;
  compareAuditById?: Maybe<AuditCompareResult>;
  computeStageDurations?: Maybe<StageDurationResult>;
  contactMessageById?: Maybe<ContactMessage>;
  filesByProjectState: StateFilesResponse;
  /** @deprecated Use `notifications` for server-side pagination instead of loading every notification. */
  getAllNotifications: Array<Notification>;
  getForwardedComment?: Maybe<Comment>;
  getRepliesForComment: Array<Comment>;
  getUserComments: Array<Comment>;
  latestAuditChanges?: Maybe<Scalars['JSON']['output']>;
  myCompanies?: Maybe<Array<Company>>;
  mySalesRequests: Array<SalesRequest>;
  notifications: NotificationPage;
  pendingSalesRequests: Array<SalesRequest>;
  projectById?: Maybe<Project>;
  projectStatusCounts: ProjectStatusCounts;
  projectsByStatus: Array<Project>;
  readFileAsGeoJSON: Array<GeoJsonFeature>;
  recentComments: CommentPage;
  salesRequestById?: Maybe<SalesRequest>;
  salesRequests: Array<SalesRequest>;
  serviceById?: Maybe<Service>;
  setting?: Maybe<Setting>;
  unreadNotificationsCount: Scalars['Int']['output'];
  userById?: Maybe<User>;
  userDirectory: Array<UserDirectoryItem>;
  workflowByServiceName?: Maybe<Workflow>;
  workflowByServiceNameAndVersion?: Maybe<Workflow>;
  workflowStateByIndex?: Maybe<WorkflowStage>;
};


export type QueryAllAuditsArgs = {
  resourceId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QueryAllCommentsArgs = {
  index: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  serviceName: Scalars['String']['input'];
};


export type QueryAllContactMessagesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAllFilesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  projectId: Scalars['ID']['input'];
  selection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllProjectsArgs = {
  assignment?: InputMaybe<ProjectAssignment>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  selection?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectStatus>;
};


export type QueryAllServicesArgs = {
  selection?: InputMaybe<ServicesSelection>;
};


export type QueryAllSettingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuditByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuditDifferencesArgs = {
  from: Scalars['Date']['input'];
  resourceId: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
  type: Scalars['String']['input'];
};


export type QueryCompaniesByOwnerIdArgs = {
  ownerId: Scalars['ID']['input'];
};


export type QueryCompanyByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryCompanyByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompareAuditByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryComputeStageDurationsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactMessageByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFilesByProjectStateArgs = {
  projectId: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};


export type QueryGetForwardedCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRepliesForCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUserCommentsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLatestAuditChangesArgs = {
  resourceId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QueryNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProjectByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectsByStatusArgs = {
  status: ProjectStatus;
};


export type QueryReadFileAsGeoJsonArgs = {
  fileId: Scalars['ID']['input'];
};


export type QueryRecentCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySalesRequestByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySalesRequestsArgs = {
  status?: InputMaybe<SalesRequestStatus>;
};


export type QueryServiceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySettingArgs = {
  key: Scalars['String']['input'];
};


export type QueryUserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkflowByServiceNameArgs = {
  serviceName: Scalars['String']['input'];
};


export type QueryWorkflowByServiceNameAndVersionArgs = {
  serviceName: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type QueryWorkflowStateByIndexArgs = {
  index: Scalars['Int']['input'];
  serviceName: Scalars['String']['input'];
  version: Scalars['Float']['input'];
};

export type RecentComment = {
  __typename?: 'RecentComment';
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  comment: Scalars['String']['output'];
  forward?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['String']['output']>;
  metadata: Metadata;
  parentCommentId?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  projectTitle?: Maybe<Scalars['String']['output']>;
  replies?: Maybe<Array<Scalars['String']['output']>>;
  service_name?: Maybe<Scalars['String']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  targetRoles?: Maybe<Array<Scalars['String']['output']>>;
  targetUsers?: Maybe<Array<Scalars['String']['output']>>;
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type RecentCommentStage = {
  __typename?: 'RecentCommentStage';
  index: Scalars['String']['output'];
  name: Scalars['String']['output'];
  serviceLabel: Scalars['String']['output'];
  service_name: Scalars['String']['output'];
};

export type RegisterUserWithCompanyInput = {
  captchaResponse: Scalars['String']['input'];
  companyData: CreateCompanyInput;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  profile: ProfileInput;
  roles?: InputMaybe<Array<Role>>;
};

export type RegistrationResult = {
  __typename?: 'RegistrationResult';
  company: Company;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: User;
};

export type RequestResetPasswordInput = {
  email: Scalars['String']['input'];
};

export type RestrictCommentInput = {
  id: Scalars['ID']['input'];
  targetRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  targetUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ReviewAction {
  Approve = 'APPROVE',
  Reject = 'REJECT',
  RequestUpdate = 'REQUEST_UPDATE'
}

export type ReviewResult = {
  __typename?: 'ReviewResult';
  message: Scalars['String']['output'];
  project?: Maybe<Project>;
  salesRequest?: Maybe<SalesRequest>;
  success: Scalars['Boolean']['output'];
};

export enum Role {
  Client = 'CLIENT',
  DataAnalyst = 'DATA_ANALYST',
  FieldOperator = 'FIELD_OPERATOR',
  MadarAdmin = 'MADAR_ADMIN',
  ProviderAdmin = 'PROVIDER_ADMIN',
  SalesRepresentative = 'SALES_REPRESENTATIVE',
  System = 'SYSTEM'
}

export type SalesRequest = {
  __typename?: 'SalesRequest';
  adminReviewNotes?: Maybe<Scalars['String']['output']>;
  adminReviewer?: Maybe<User>;
  adminReviewerId?: Maybe<Scalars['String']['output']>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientName: Scalars['String']['output'];
  clientPhone?: Maybe<Scalars['String']['output']>;
  contractDocuments?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  expectedDataType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkedProject?: Maybe<Project>;
  linkedProjectId?: Maybe<Scalars['String']['output']>;
  quotationAmount?: Maybe<Scalars['Float']['output']>;
  requestedServices: Array<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  salesRep?: Maybe<User>;
  salesRepId: Scalars['String']['output'];
  status: SalesRequestStatus;
  submittedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum SalesRequestStatus {
  Approved = 'approved',
  NeedsUpdate = 'needs_update',
  PendingReview = 'pending_review',
  Rejected = 'rejected'
}

export type SendContactMessageInput = {
  captchaResponse: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export enum SensorPayload {
  Multispectral_5Band = 'MULTISPECTRAL_5_BAND',
  Rgb_20Mp = 'RGB_20MP',
  Rgb_48Mp = 'RGB_48MP',
  ThermalIr_640_512 = 'THERMAL_IR_640_512',
  ThermalIr_1280_1024 = 'THERMAL_IR_1280_1024'
}

export type Service = {
  __typename?: 'Service';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ServicesSelection {
  All = 'all',
  Deleted = 'deleted',
  NonDeleted = 'non_deleted'
}

export type Setting = {
  __typename?: 'Setting';
  TTL: Scalars['Int']['output'];
  defaultValue: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  metadata: Metadata;
  type: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type SettingMutationResponse = {
  __typename?: 'SettingMutationResponse';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  message: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type SettingUpdateInput = {
  TTL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type StageDuration = {
  __typename?: 'StageDuration';
  actual_time: Scalars['Float']['output'];
  estimated_time?: Maybe<EstimatedTime>;
  state: Scalars['Int']['output'];
  users: Array<StageUser>;
};

export type StageDurationResult = {
  __typename?: 'StageDurationResult';
  projectId: Scalars['ID']['output'];
  stages: Array<StageDuration>;
};

export type StageUser = {
  __typename?: 'StageUser';
  from: Scalars['Date']['output'];
  to?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type StateDataItem = {
  __typename?: 'StateDataItem';
  area?: Maybe<Scalars['String']['output']>;
  data?: Maybe<ProjectInspection>;
  drawnFeatures?: Maybe<Array<GeoJsonFeature>>;
  estimatedTimes?: Maybe<EstimatedStageTime>;
  files?: Maybe<Array<Scalars['String']['output']>>;
  state?: Maybe<Scalars['Int']['output']>;
};

export type StateDataItemInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<ProjectInspectionInput>;
  drawnFeatures?: InputMaybe<Array<GeoJsonFeatureInput>>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  state: Scalars['Int']['input'];
};

export type StateFilesResponse = {
  __typename?: 'StateFilesResponse';
  files: Array<File>;
};

export type Subscription = {
  __typename?: 'Subscription';
  fileUpdates?: Maybe<FileUpdate>;
  projectAssignmentChanged: ProjectAssignmentUpdate;
  userNotification?: Maybe<NotificationItem>;
};


export type SubscriptionFileUpdatesArgs = {
  fileId: Scalars['ID']['input'];
};

export type TechnicalMetrics = {
  __typename?: 'TechnicalMetrics';
  achievedGsdCm?: Maybe<Scalars['Float']['output']>;
  completeness?: Maybe<Scalars['Boolean']['output']>;
  geometricAccuracy?: Maybe<Scalars['Boolean']['output']>;
  rmse?: Maybe<Scalars['Float']['output']>;
  visualInspection?: Maybe<Scalars['Boolean']['output']>;
};

export type TechnicalMetricsInput = {
  achievedGsdCm?: InputMaybe<Scalars['Float']['input']>;
  completeness?: InputMaybe<Scalars['Boolean']['input']>;
  geometricAccuracy?: InputMaybe<Scalars['Boolean']['input']>;
  rmse?: InputMaybe<Scalars['Float']['input']>;
  visualInspection?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TimeUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type UpdateCompanyInput = {
  address?: InputMaybe<AddressInput>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyStateInput = {
  state: CompanyState;
};

export type UpdateProjectInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Array<StateDataItemInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<ProjectServiceItemInput>;
  timeline?: InputMaybe<ProjectTimelineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectStatusInput = {
  status: ProjectStatus;
};

export type UpdateSalesRequestInput = {
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  contractDocuments?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedDataType?: InputMaybe<Scalars['String']['input']>;
  quotationAmount?: InputMaybe<Scalars['Float']['input']>;
  requestedServices?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateUserInput = {
  profile?: InputMaybe<ProfileInput>;
  roles?: InputMaybe<Array<Role>>;
  state?: InputMaybe<UserState>;
};

export type UploadedFileMeta = {
  __typename?: 'UploadedFileMeta';
  key?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName: Scalars['String']['output'];
  size?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadedFileMetaInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  originalName: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['ID']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
  metadata: Metadata;
  numberOfFailedLoginAttempts?: Maybe<Scalars['Int']['output']>;
  profile: Profile;
  resetPasswordCode?: Maybe<Scalars['String']['output']>;
  resetPasswordCodeExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  state?: Maybe<UserState>;
};

export type UserDirectoryItem = {
  __typename?: 'UserDirectoryItem';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  profile: UserDirectoryProfile;
};

export type UserDirectoryProfile = {
  __typename?: 'UserDirectoryProfile';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export enum UserState {
  Active = 'active',
  Locked = 'locked',
  Pending = 'pending',
  Suspended = 'suspended'
}

export type VerifiedUser = {
  __typename?: 'VerifiedUser';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  state: UserState;
};

export type VerifyEmailInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type VerifyEmailResponse = {
  __typename?: 'VerifyEmailResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user?: Maybe<VerifiedUser>;
};

export type Workflow = {
  __typename?: 'Workflow';
  id: Scalars['ID']['output'];
  metadata?: Maybe<WorkflowMetadata>;
  service_name: Scalars['String']['output'];
  stages: Array<WorkflowStage>;
  version: Scalars['Float']['output'];
};

export type WorkflowAction = {
  __typename?: 'WorkflowAction';
  branch_by?: Maybe<Scalars['String']['output']>;
  comment_required?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  state: Scalars['IntOrIntArray']['output'];
};

export type WorkflowMetadata = {
  __typename?: 'WorkflowMetadata';
  createdAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type WorkflowStage = {
  __typename?: 'WorkflowStage';
  actions: Array<WorkflowAction>;
  comment_required?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  estimate_other_stages?: Maybe<Array<Scalars['Int']['output']>>;
  estimated_time?: Maybe<EstimatedTime>;
  name: Scalars['String']['output'];
  role: Array<Scalars['String']['output']>;
  state: Scalars['Int']['output'];
  visibility_roles: Array<Scalars['String']['output']>;
};

export type LoginResponse = {
  __typename?: 'loginResponse';
  message?: Maybe<Scalars['String']['output']>;
  userData?: Maybe<User>;
};

export type LogoutResponse = {
  __typename?: 'logoutResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type AllAuditsQueryVariables = Exact<{
  type: Scalars['String']['input'];
  resourceId: Scalars['ID']['input'];
}>;


export type AllAuditsQuery = { __typename?: 'Query', allAudits: Array<{ __typename?: 'Audit', id: string, type: string, data?: any | null, metadata: { __typename?: 'AuditMetadata', createdAt?: any | null, updatedAt?: any | null, updatedBy?: string | null } }> };

export type GetProjectAuditsQueryVariables = Exact<{
  type: Scalars['String']['input'];
  resourceId: Scalars['ID']['input'];
}>;


export type GetProjectAuditsQuery = { __typename?: 'Query', allAudits: Array<{ __typename?: 'Audit', id: string, data?: any | null, metadata: { __typename?: 'AuditMetadata', createdAt?: any | null, updatedBy?: string | null } }> };

export type AuditDifferencesQueryVariables = Exact<{
  type: Scalars['String']['input'];
  resourceId: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type AuditDifferencesQuery = { __typename?: 'Query', auditDifferences: Array<{ __typename?: 'Audit', id: string, type: string, data?: any | null, metadata: { __typename?: 'AuditMetadata', createdAt?: any | null, updatedAt?: any | null, updatedBy?: string | null } }> };

export type CompareAuditByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompareAuditByIdQuery = { __typename?: 'Query', compareAuditById?: { __typename?: 'AuditCompareResult', auditId: string, type: string, resourceId: string, comparedWith: string, previousAuditId?: string | null, changes?: any | null } | null };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'loginResponse', message?: string | null, userData?: { __typename?: 'User', _id?: string | null, email: string, roles?: Array<Role | null> | null, companyId?: string | null, state?: UserState | null, lastSeen?: any | null, profile: { __typename?: 'Profile', firstName: string, lastName: string }, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } } | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'logoutResponse', message?: string | null } | null };

export type RequestResetPasswordMutationVariables = Exact<{
  input: RequestResetPasswordInput;
}>;


export type RequestResetPasswordMutation = { __typename?: 'Mutation', requestResetPassword: string };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'User', _id?: string | null, email: string, profile: { __typename?: 'Profile', firstName: string, lastName: string } } | null };

export type ChangeOwnPasswordMutationVariables = Exact<{
  input: ChangeOwnPasswordInput;
}>;


export type ChangeOwnPasswordMutation = { __typename?: 'Mutation', changeOwnPassword: boolean };

export type VerifyEmailMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail?: { __typename?: 'VerifyEmailResponse', success: boolean, message: string, user?: { __typename?: 'VerifiedUser', id: string, email: string, state: UserState } | null } | null };

export type RestrictCommentVisibilityMutationVariables = Exact<{
  input: RestrictCommentInput;
}>;


export type RestrictCommentVisibilityMutation = { __typename?: 'Mutation', restrictCommentVisibility: { __typename?: 'Comment', id: string, comment: string, projectId: string, userId: string, userName?: string | null, service_name: string, index: string, parentCommentId?: string | null, targetRoles?: Array<string> | null, targetUsers?: Array<string> | null, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } } };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', id: string, comment: string, projectId: string, userId: string, userName?: string | null, service_name: string, index: string, parentCommentId?: string | null, targetRoles?: Array<string> | null, targetUsers?: Array<string> | null, attachments?: Array<string> | null, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } } };

export type ReplyToCommentMutationVariables = Exact<{
  input: CreateReplyInput;
}>;


export type ReplyToCommentMutation = { __typename?: 'Mutation', replyToComment: { __typename?: 'Comment', id: string, comment: string, projectId: string, userId: string, userName?: string | null, service_name: string, index: string, parentCommentId?: string | null, targetRoles?: Array<string> | null, targetUsers?: Array<string> | null, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } } };

export type ForwardCommentMutationVariables = Exact<{
  input: ForwardCommentInput;
}>;


export type ForwardCommentMutation = { __typename?: 'Mutation', forwardComment: { __typename?: 'Comment', id: string, comment: string, projectId: string, userId: string, userName?: string | null, service_name: string, index: string, parentCommentId?: string | null, targetRoles?: Array<string> | null, targetUsers?: Array<string> | null, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } } };

export type GetUserCommentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserCommentsQuery = { __typename?: 'Query', getUserComments: Array<{ __typename?: 'Comment', id: string, comment: string, projectId: string, userId: string, userName?: string | null, service_name: string, index: string, parentCommentId?: string | null, targetRoles?: Array<string> | null, targetUsers?: Array<string> | null, attachments?: Array<string> | null, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } }> };

export type AllCommentsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  serviceName: Scalars['String']['input'];
  index: Scalars['String']['input'];
}>;


export type AllCommentsQuery = { __typename?: 'Query', allComments: Array<{ __typename?: 'Comment', id: string, comment: string, projectId: string, userId: string, userName?: string | null, service_name: string, index: string, parentCommentId?: string | null, targetRoles?: Array<string> | null, targetUsers?: Array<string> | null, attachments?: Array<string> | null, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } }> };

export type RecentCommentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecentCommentsQuery = { __typename?: 'Query', recentComments: { __typename?: 'CommentPage', total: number, stages: Array<{ __typename?: 'RecentCommentStage', service_name: string, serviceLabel: string, index: string, name: string }>, items: Array<{ __typename?: 'RecentComment', id: string, comment: string, projectId: string, projectTitle?: string | null, userId: string, userName?: string | null, service_name?: string | null, index?: string | null, stageName?: string | null, parentCommentId?: string | null, forward?: string | null, targetRoles?: Array<string> | null, targetUsers?: Array<string> | null, attachments?: Array<string> | null, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } }> } };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'CreateCompanyResponse', message: string } };

export type AllCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCompaniesQuery = { __typename?: 'Query', allCompanies?: Array<{ __typename?: 'Company', id: string, companyName: string, state: CompanyState, ownerId: string }> | null };

export type CompanyByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompanyByIdQuery = { __typename?: 'Query', companyById?: { __typename?: 'Company', id: string, companyName: string, state: CompanyState, ownerId: string } | null };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile: { __typename?: 'DeleteFileResponse', success: boolean, message: string } };

export type AllFilesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  selection?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type AllFilesQuery = { __typename?: 'Query', allFiles: { __typename?: 'FilesResponse', files: Array<{ __typename?: 'File', id: string, name: string, status: FileStatus, state?: number | null, physical_name: string, projectId: string, serviceId?: string | null, ownerId: string, size: number, type: string, isDeleted: boolean, geojson_table?: string | null, geojson_import_error?: string | null, geojson_import_status?: string | null, metadata?: { __typename?: 'FileMetadata', createdAt?: any | null, updatedAt?: any | null } | null }>, pagination: { __typename?: 'Pagination', page: number, limit: number, maxLimit: number, sort?: string | null, order?: string | null, count: number } } };

export type FilesByProjectStateQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  state: Scalars['String']['input'];
}>;


export type FilesByProjectStateQuery = { __typename?: 'Query', filesByProjectState: { __typename?: 'StateFilesResponse', files: Array<{ __typename?: 'File', id: string, name: string, physical_name: string, projectId: string, serviceId?: string | null, ownerId: string, state?: number | null, size: number, type: string, status: FileStatus, isDeleted: boolean, geojson_table?: string | null, geojson_import_error?: string | null, geojson_import_status?: string | null, metadata?: { __typename?: 'FileMetadata', createdAt?: any | null, updatedAt?: any | null } | null }> } };

export type ReadFileAsGeoJsonQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type ReadFileAsGeoJsonQuery = { __typename?: 'Query', readFileAsGeoJSON: Array<{ __typename?: 'GeoJSONFeature', type: string, geometry: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any }, properties?: { __typename?: 'GeoJSONProperties', name?: string | null, fileId?: string | null } | null }> };

export type FileUpdatesSubscriptionVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type FileUpdatesSubscription = { __typename?: 'Subscription', fileUpdates?: { __typename?: 'FileUpdate', fileId: string } | null };

export type MarkContactMessageAsReadMutationVariables = Exact<{
  input: MarkAsReadInput;
}>;


export type MarkContactMessageAsReadMutation = { __typename?: 'Mutation', markContactMessageAsRead: { __typename?: 'ContactMessage', id: string, read?: { __typename?: 'ContactMessageRead', readDate?: any | null, readUser?: string | null } | null } };

export type SendContactMessageMutationVariables = Exact<{
  input: SendContactMessageInput;
}>;


export type SendContactMessageMutation = { __typename?: 'Mutation', sendContactMessage: { __typename?: 'ContactMessage', id: string, name?: string | null, email?: string | null, company?: string | null, message?: string | null, title?: string | null, phone?: string | null, read?: { __typename?: 'ContactMessageRead', readDate?: any | null, readUser?: string | null } | null, metadata?: { __typename?: 'GuestContactMetadata', createdAt?: any | null } | null } };

export type AllContactMessagesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type AllContactMessagesQuery = { __typename?: 'Query', allContactMessages: { __typename?: 'ContactMessagesResponse', messages: Array<{ __typename?: 'ContactMessage', id: string, name?: string | null, email?: string | null, company?: string | null, message?: string | null, title?: string | null, phone?: string | null, ip?: string | null, read?: { __typename?: 'ContactMessageRead', readDate?: any | null, readUser?: string | null } | null, metadata?: { __typename?: 'GuestContactMetadata', createdAt?: any | null, updatedAt?: any | null } | null }>, pagination: { __typename?: 'Pagination', page: number, limit: number, maxLimit: number, count: number } } };

export type ContactMessageByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactMessageByIdQuery = { __typename?: 'Query', contactMessageById?: { __typename?: 'ContactMessage', id: string, name?: string | null, email?: string | null, company?: string | null, message?: string | null, title?: string | null, phone?: string | null, ip?: string | null, read?: { __typename?: 'ContactMessageRead', readDate?: any | null, readUser?: string | null } | null, metadata?: { __typename?: 'GuestContactMetadata', createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type SetNotificationSeenMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type SetNotificationSeenMutation = { __typename?: 'Mutation', setNotificationSeen: { __typename?: 'Notification', id: string, roles?: Array<string> | null, users?: Array<string> | null, timeToLive?: number | null, seenTimeToLive?: number | null, seen?: Array<string> | null, title: string, body: string, every_one: boolean, metadata?: { __typename?: 'NotificationMetadata', createdAt?: any | null, updatedAt?: any | null } | null } };

export type NotificationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationPage', total: number, items: Array<{ __typename?: 'Notification', id: string, roles?: Array<string> | null, users?: Array<string> | null, timeToLive?: number | null, seenTimeToLive?: number | null, seen?: Array<string> | null, link?: string | null, title: string, body: string, every_one: boolean, metadata?: { __typename?: 'NotificationMetadata', createdAt?: any | null, updatedAt?: any | null } | null }> } };

export type UnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCountQuery = { __typename?: 'Query', unreadNotificationsCount: number };

export type UserNotificationSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationSubscriptionSubscription = { __typename?: 'Subscription', userNotification?: { __typename?: 'NotificationItem', id: string, title: string, body: string, link?: string | null, seen?: Array<string> | null, metadata?: { __typename?: 'NotificationMetadata', createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, title: string, description: string, status: ProjectStatus, companyId: string, assignedTo?: string | null, ownerId?: string | null, isDeleted: boolean, service?: { __typename?: 'ProjectServiceItem', serviceId: string, serviceName?: string | null, status?: string | null, notes?: string | null, workflow_version?: number | null, current_state?: number | null, prev_state?: number | null, scheduledDate?: any | null } | null, data?: Array<{ __typename?: 'StateDataItem', state?: number | null, files?: Array<string> | null, area?: string | null, data?: { __typename?: 'ProjectInspection', priority?: ProjectPriority | null, dataSource?: DataSource | null, gcpSource?: GcpSource | null, analysisLevel?: AnalysisLevel | null, gsdAccuracyProfile?: GsdAccuracyProfile | null, gsd?: string | null, flightAltitude?: string | null, sensor?: Array<SensorPayload> | null, potentialRisks?: Array<PotentialRisk> | null, deliverables?: Array<{ __typename?: 'ProjectDeliverable', category?: DeliverableCategory | null, options: Array<DeliverableOption>, outputFormats: Array<OutputFormat> }> | null, technicalQualityChecklist?: { __typename?: 'ProjectInspectionTechnicalQualityChecklist', imageResolutionMet?: boolean | null, completeSiteCoverageVerified?: boolean | null, noMissingOrCorruptedFiles?: boolean | null, thermalCalibrationDataPresent?: boolean | null, metadataGeolocationValid?: boolean | null, fileFormatCompatibilityConfirmed?: boolean | null } | null, pricingProposal?: { __typename?: 'ProjectPricingProposal', proposedPrice?: string | null, currency?: string | null } | null, missionDesign?: { __typename?: 'ProjectInspectionMission', numberOfMissions?: string | null, coverageAreaHectares?: string | null, estimatedFlightTimeHours?: string | null, flightDate?: any | null, flightDurationMinutes?: number | null, imageCount?: number | null } | null, imageUpload?: { __typename?: 'ImageUpload', numberOfImages?: number | null } | null, gcpUpload?: { __typename?: 'GcpUpload', coordinateSystem?: string | null, fileName?: string | null, pointCount?: number | null } | null, plant?: { __typename?: 'ProjectInspectionPlant', plantType?: PlantType | null, mountingType?: MountingType | null, installedCapacityMW?: number | null } | null, module?: { __typename?: 'ProjectInspectionModule', manufacturer?: string | null, panelType?: PanelType | null, width?: string | null, height?: string | null } | null } | null, drawnFeatures?: Array<{ __typename?: 'GeoJSONFeature', type: string, properties?: { __typename?: 'GeoJSONProperties', name?: string | null } | null, geometry: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } }> | null }> | null, timeline?: { __typename?: 'ProjectTimeline', startDate?: any | null, endDate?: any | null, estimatedDuration?: number | null } | null, metadata?: { __typename?: 'ProjectMetadata', createdAt?: any | null, updatedAt?: any | null } | null } };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, title: string, description: string, status: ProjectStatus, companyId: string, assignedTo?: string | null, ownerId?: string | null, isDeleted: boolean, service?: { __typename?: 'ProjectServiceItem', serviceId: string, serviceName?: string | null, status?: string | null, notes?: string | null, workflow_version?: number | null, current_state?: number | null, prev_state?: number | null, scheduledDate?: any | null } | null, data?: Array<{ __typename?: 'StateDataItem', state?: number | null, files?: Array<string> | null, area?: string | null, data?: { __typename?: 'ProjectInspection', priority?: ProjectPriority | null, dataSource?: DataSource | null, gcpSource?: GcpSource | null, analysisLevel?: AnalysisLevel | null, gsdAccuracyProfile?: GsdAccuracyProfile | null, gsd?: string | null, flightAltitude?: string | null, sensor?: Array<SensorPayload> | null, potentialRisks?: Array<PotentialRisk> | null, deliverables?: Array<{ __typename?: 'ProjectDeliverable', category?: DeliverableCategory | null, options: Array<DeliverableOption>, outputFormats: Array<OutputFormat> }> | null, technicalQualityChecklist?: { __typename?: 'ProjectInspectionTechnicalQualityChecklist', imageResolutionMet?: boolean | null, completeSiteCoverageVerified?: boolean | null, noMissingOrCorruptedFiles?: boolean | null, thermalCalibrationDataPresent?: boolean | null, metadataGeolocationValid?: boolean | null, fileFormatCompatibilityConfirmed?: boolean | null } | null, pricingProposal?: { __typename?: 'ProjectPricingProposal', proposedPrice?: string | null, currency?: string | null } | null, missionDesign?: { __typename?: 'ProjectInspectionMission', numberOfMissions?: string | null, coverageAreaHectares?: string | null, estimatedFlightTimeHours?: string | null, flightDate?: any | null, flightDurationMinutes?: number | null, imageCount?: number | null } | null, imageUpload?: { __typename?: 'ImageUpload', numberOfImages?: number | null } | null, gcpUpload?: { __typename?: 'GcpUpload', coordinateSystem?: string | null, fileName?: string | null, pointCount?: number | null } | null, plant?: { __typename?: 'ProjectInspectionPlant', plantType?: PlantType | null, mountingType?: MountingType | null, installedCapacityMW?: number | null } | null, module?: { __typename?: 'ProjectInspectionModule', manufacturer?: string | null, panelType?: PanelType | null, width?: string | null, height?: string | null } | null } | null, drawnFeatures?: Array<{ __typename?: 'GeoJSONFeature', type: string, properties?: { __typename?: 'GeoJSONProperties', name?: string | null } | null, geometry: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } }> | null }> | null, timeline?: { __typename?: 'ProjectTimeline', startDate?: any | null, endDate?: any | null, estimatedDuration?: number | null } | null, metadata?: { __typename?: 'ProjectMetadata', createdAt?: any | null, updatedAt?: any | null } | null } };

export type UpdateProjectStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateProjectStatusInput;
}>;


export type UpdateProjectStatusMutation = { __typename?: 'Mutation', updateProjectStatus: { __typename?: 'Project', id: string, status: ProjectStatus, metadata?: { __typename?: 'ProjectMetadata', createdAt?: any | null, updatedAt?: any | null } | null } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'DeleteResponse', success: boolean, message: string } };

export type UpdateProjectAssignedToMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectAssignedToMutation = { __typename?: 'Mutation', updateProjectAssignedTo: { __typename?: 'Project', id: string, assignedTo?: string | null, ownerId?: string | null, metadata?: { __typename?: 'ProjectMetadata', updatedAt?: any | null } | null } };

export type AllProjectsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectStatus>;
  assignment?: InputMaybe<ProjectAssignment>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type AllProjectsQuery = { __typename?: 'Query', allProjects: { __typename?: 'ProjectsResponse', projects: Array<{ __typename?: 'Project', id: string, title: string, description: string, status: ProjectStatus, companyId: string, assignedTo?: string | null, ownerId?: string | null, isDeleted: boolean, priorityRank?: number | null, progress?: number | null, service?: { __typename?: 'ProjectServiceItem', serviceName?: string | null, current_state?: number | null, current_state_started_at?: any | null, workflow_version?: number | null } | null, timeline?: { __typename?: 'ProjectTimeline', startDate?: any | null, endDate?: any | null, estimatedDuration?: number | null } | null, metadata?: { __typename?: 'ProjectMetadata', createdAt?: any | null, updatedAt?: any | null } | null }>, pagination: { __typename?: 'Pagination', page: number, limit: number, maxLimit: number, sort?: string | null, order?: string | null, count: number } } };

export type ProjectStatusCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectStatusCountsQuery = { __typename?: 'Query', projectStatusCounts: { __typename?: 'ProjectStatusCounts', total: number, counts: Array<{ __typename?: 'ProjectStatusCount', status: ProjectStatus, count: number }> } };

export type ProjectByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectByIdQuery = { __typename?: 'Query', projectById?: { __typename?: 'Project', id: string, title: string, description: string, status: ProjectStatus, companyId: string, assignedTo?: string | null, ownerId?: string | null, isDeleted: boolean, service?: { __typename?: 'ProjectServiceItem', serviceId: string, serviceName?: string | null, status?: string | null, notes?: string | null, workflow_version?: number | null, current_state?: number | null, prev_state?: number | null, scheduledDate?: any | null } | null, data?: Array<{ __typename?: 'StateDataItem', state?: number | null, files?: Array<string> | null, area?: string | null, data?: { __typename?: 'ProjectInspection', priority?: ProjectPriority | null, dataSource?: DataSource | null, gcpSource?: GcpSource | null, analysisLevel?: AnalysisLevel | null, gsdAccuracyProfile?: GsdAccuracyProfile | null, gsd?: string | null, flightAltitude?: string | null, sensor?: Array<SensorPayload> | null, potentialRisks?: Array<PotentialRisk> | null, deliverables?: Array<{ __typename?: 'ProjectDeliverable', category?: DeliverableCategory | null, options: Array<DeliverableOption>, outputFormats: Array<OutputFormat> }> | null, technicalQualityChecklist?: { __typename?: 'ProjectInspectionTechnicalQualityChecklist', imageResolutionMet?: boolean | null, completeSiteCoverageVerified?: boolean | null, noMissingOrCorruptedFiles?: boolean | null, thermalCalibrationDataPresent?: boolean | null, metadataGeolocationValid?: boolean | null, fileFormatCompatibilityConfirmed?: boolean | null } | null, pricingProposal?: { __typename?: 'ProjectPricingProposal', proposedPrice?: string | null, currency?: string | null } | null, missionDesign?: { __typename?: 'ProjectInspectionMission', numberOfMissions?: string | null, coverageAreaHectares?: string | null, estimatedFlightTimeHours?: string | null, flightDate?: any | null, flightDurationMinutes?: number | null, imageCount?: number | null } | null, imageUpload?: { __typename?: 'ImageUpload', numberOfImages?: number | null } | null, gcpUpload?: { __typename?: 'GcpUpload', coordinateSystem?: string | null, fileName?: string | null, pointCount?: number | null } | null, plant?: { __typename?: 'ProjectInspectionPlant', plantType?: PlantType | null, mountingType?: MountingType | null, installedCapacityMW?: number | null } | null, module?: { __typename?: 'ProjectInspectionModule', manufacturer?: string | null, panelType?: PanelType | null, width?: string | null, height?: string | null } | null } | null }> | null, timeline?: { __typename?: 'ProjectTimeline', startDate?: any | null, endDate?: any | null, estimatedDuration?: number | null } | null, metadata?: { __typename?: 'ProjectMetadata', createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type ProjectAssignmentChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ProjectAssignmentChangedSubscription = { __typename?: 'Subscription', projectAssignmentChanged: { __typename?: 'ProjectAssignmentUpdate', projectId: string, changedAt: string } };

export type AllServicesQueryVariables = Exact<{
  selection?: InputMaybe<ServicesSelection>;
}>;


export type AllServicesQuery = { __typename?: 'Query', allServices: Array<{ __typename?: 'Service', id: string, name: string, description: string, tags?: Array<string> | null, icon?: string | null, isDeleted?: boolean | null, createdAt: any, updatedAt: any }> };

export type ServiceByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ServiceByIdQuery = { __typename?: 'Query', serviceById?: { __typename?: 'Service', id: string, name: string, description: string, tags?: Array<string> | null, icon?: string | null, isDeleted?: boolean | null, createdAt: any, updatedAt: any } | null };

export type UpdateSettingMutationVariables = Exact<{
  key: Scalars['String']['input'];
  input: SettingUpdateInput;
}>;


export type UpdateSettingMutation = { __typename?: 'Mutation', updateSetting: { __typename?: 'Setting', key: string, label: string, value: any, defaultValue: any, type: string, TTL: number, description?: string | null, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } } };

export type AllSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSettingsQuery = { __typename?: 'Query', allSettings?: Array<{ __typename?: 'Setting', key: string, label: string, value: any, defaultValue: any, type: string, TTL: number, description?: string | null, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } } | null> | null };

export type RegisterUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', _id?: string | null, email: string, roles?: Array<Role | null> | null, state?: UserState | null, profile: { __typename?: 'Profile', firstName: string, lastName: string } } };

export type UpdateUserMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id?: string | null, email: string, roles?: Array<Role | null> | null, companyId?: string | null, state?: UserState | null, profile: { __typename?: 'Profile', firstName: string, lastName: string, additionalData?: any | null }, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } } };

export type RegisterUserWithCompanyMutationVariables = Exact<{
  input: RegisterUserWithCompanyInput;
}>;


export type RegisterUserWithCompanyMutation = { __typename?: 'Mutation', registerUserWithCompany: { __typename?: 'RegistrationResult', success: boolean, message: string, user: { __typename?: 'User', _id?: string | null, email: string, roles?: Array<Role | null> | null, state?: UserState | null, profile: { __typename?: 'Profile', firstName: string, lastName: string } }, company: { __typename?: 'Company', id: string, companyName: string, email: string, businessType?: string | null, state: CompanyState } } };

export type AllUsersForCommentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllUsersForCommentsQuery = { __typename?: 'Query', allUsers?: Array<{ __typename?: 'User', id?: string | null, email: string, roles?: Array<Role | null> | null, companyId?: string | null, state?: UserState | null, profile: { __typename?: 'Profile', firstName: string, lastName: string, additionalData?: any | null }, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } } | null> | null };

export type UserByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'User', _id?: string | null, email: string, roles?: Array<Role | null> | null, companyId?: string | null, state?: UserState | null, lastSeen?: any | null, profile: { __typename?: 'Profile', firstName: string, lastName: string }, metadata: { __typename?: 'Metadata', createdAt: any, updatedAt: any } } | null };

export type UserDirectoryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDirectoryQuery = { __typename?: 'Query', userDirectory: Array<{ __typename?: 'UserDirectoryItem', id: string, email: string, profile: { __typename?: 'UserDirectoryProfile', firstName: string, lastName: string } }> };

export type SetWorkflowStateMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type SetWorkflowStateMutation = { __typename?: 'Mutation', setWorkflowState: { __typename?: 'Project', id: string, status: ProjectStatus, service?: { __typename?: 'ProjectServiceItem', workflow_version?: number | null, current_state?: number | null, prev_state?: number | null } | null, metadata?: { __typename?: 'ProjectMetadata', updatedAt?: any | null } | null } };

export type ExecuteWorkflowActionMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  action: Scalars['String']['input'];
}>;


export type ExecuteWorkflowActionMutation = { __typename?: 'Mutation', executeWorkflowAction: { __typename?: 'Project', id: string, status: ProjectStatus, service?: { __typename?: 'ProjectServiceItem', workflow_version?: number | null, current_state?: number | null, prev_state?: number | null } | null, metadata?: { __typename?: 'ProjectMetadata', updatedAt?: any | null } | null } };

export type ComputeStageDurationsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ComputeStageDurationsQuery = { __typename?: 'Query', computeStageDurations?: { __typename?: 'StageDurationResult', projectId: string, stages: Array<{ __typename?: 'StageDuration', state: number, actual_time: number, users: Array<{ __typename?: 'StageUser', userId?: string | null, userName?: string | null, from: any, to?: any | null }> }> } | null };

export type GetWorkflowStagesQueryVariables = Exact<{
  serviceName: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;


export type GetWorkflowStagesQuery = { __typename?: 'Query', workflowByServiceNameAndVersion?: { __typename?: 'Workflow', stages: Array<{ __typename?: 'WorkflowStage', state: number, name: string, description: string, role: Array<string>, visibility_roles: Array<string>, comment_required?: boolean | null, estimate_other_stages?: Array<number> | null, actions: Array<{ __typename?: 'WorkflowAction', name: string, state: any, comment_required?: boolean | null, branch_by?: string | null }>, estimated_time?: { __typename?: 'EstimatedTime', value: number, unit: TimeUnit } | null }> } | null };


export const AllAuditsDocument = gql`
    query AllAudits($type: String!, $resourceId: ID!) {
  allAudits(type: $type, resourceId: $resourceId) {
    id
    type
    data
    metadata {
      createdAt
      updatedAt
      updatedBy
    }
  }
}
    `;

/**
 * __useAllAuditsQuery__
 *
 * To run a query within a React component, call `useAllAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAuditsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useAllAuditsQuery(baseOptions: Apollo.QueryHookOptions<AllAuditsQuery, AllAuditsQueryVariables> & ({ variables: AllAuditsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAuditsQuery, AllAuditsQueryVariables>(AllAuditsDocument, options);
      }
export function useAllAuditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAuditsQuery, AllAuditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAuditsQuery, AllAuditsQueryVariables>(AllAuditsDocument, options);
        }
// @ts-ignore
export function useAllAuditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllAuditsQuery, AllAuditsQueryVariables>): Apollo.UseSuspenseQueryResult<AllAuditsQuery, AllAuditsQueryVariables>;
export function useAllAuditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAuditsQuery, AllAuditsQueryVariables>): Apollo.UseSuspenseQueryResult<AllAuditsQuery | undefined, AllAuditsQueryVariables>;
export function useAllAuditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAuditsQuery, AllAuditsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAuditsQuery, AllAuditsQueryVariables>(AllAuditsDocument, options);
        }
export type AllAuditsQueryHookResult = ReturnType<typeof useAllAuditsQuery>;
export type AllAuditsLazyQueryHookResult = ReturnType<typeof useAllAuditsLazyQuery>;
export type AllAuditsSuspenseQueryHookResult = ReturnType<typeof useAllAuditsSuspenseQuery>;
export type AllAuditsQueryResult = Apollo.QueryResult<AllAuditsQuery, AllAuditsQueryVariables>;
export const GetProjectAuditsDocument = gql`
    query GetProjectAudits($type: String!, $resourceId: ID!) {
  allAudits(type: $type, resourceId: $resourceId) {
    id
    data
    metadata {
      createdAt
      updatedBy
    }
  }
}
    `;

/**
 * __useGetProjectAuditsQuery__
 *
 * To run a query within a React component, call `useGetProjectAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectAuditsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useGetProjectAuditsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectAuditsQuery, GetProjectAuditsQueryVariables> & ({ variables: GetProjectAuditsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectAuditsQuery, GetProjectAuditsQueryVariables>(GetProjectAuditsDocument, options);
      }
export function useGetProjectAuditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectAuditsQuery, GetProjectAuditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectAuditsQuery, GetProjectAuditsQueryVariables>(GetProjectAuditsDocument, options);
        }
// @ts-ignore
export function useGetProjectAuditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectAuditsQuery, GetProjectAuditsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectAuditsQuery, GetProjectAuditsQueryVariables>;
export function useGetProjectAuditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectAuditsQuery, GetProjectAuditsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectAuditsQuery | undefined, GetProjectAuditsQueryVariables>;
export function useGetProjectAuditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectAuditsQuery, GetProjectAuditsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectAuditsQuery, GetProjectAuditsQueryVariables>(GetProjectAuditsDocument, options);
        }
export type GetProjectAuditsQueryHookResult = ReturnType<typeof useGetProjectAuditsQuery>;
export type GetProjectAuditsLazyQueryHookResult = ReturnType<typeof useGetProjectAuditsLazyQuery>;
export type GetProjectAuditsSuspenseQueryHookResult = ReturnType<typeof useGetProjectAuditsSuspenseQuery>;
export type GetProjectAuditsQueryResult = Apollo.QueryResult<GetProjectAuditsQuery, GetProjectAuditsQueryVariables>;
export const AuditDifferencesDocument = gql`
    query AuditDifferences($type: String!, $resourceId: ID!, $from: Date!, $to: Date!) {
  auditDifferences(type: $type, resourceId: $resourceId, from: $from, to: $to) {
    id
    type
    data
    metadata {
      createdAt
      updatedAt
      updatedBy
    }
  }
}
    `;

/**
 * __useAuditDifferencesQuery__
 *
 * To run a query within a React component, call `useAuditDifferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditDifferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditDifferencesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      resourceId: // value for 'resourceId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAuditDifferencesQuery(baseOptions: Apollo.QueryHookOptions<AuditDifferencesQuery, AuditDifferencesQueryVariables> & ({ variables: AuditDifferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditDifferencesQuery, AuditDifferencesQueryVariables>(AuditDifferencesDocument, options);
      }
export function useAuditDifferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditDifferencesQuery, AuditDifferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditDifferencesQuery, AuditDifferencesQueryVariables>(AuditDifferencesDocument, options);
        }
// @ts-ignore
export function useAuditDifferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuditDifferencesQuery, AuditDifferencesQueryVariables>): Apollo.UseSuspenseQueryResult<AuditDifferencesQuery, AuditDifferencesQueryVariables>;
export function useAuditDifferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditDifferencesQuery, AuditDifferencesQueryVariables>): Apollo.UseSuspenseQueryResult<AuditDifferencesQuery | undefined, AuditDifferencesQueryVariables>;
export function useAuditDifferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditDifferencesQuery, AuditDifferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditDifferencesQuery, AuditDifferencesQueryVariables>(AuditDifferencesDocument, options);
        }
export type AuditDifferencesQueryHookResult = ReturnType<typeof useAuditDifferencesQuery>;
export type AuditDifferencesLazyQueryHookResult = ReturnType<typeof useAuditDifferencesLazyQuery>;
export type AuditDifferencesSuspenseQueryHookResult = ReturnType<typeof useAuditDifferencesSuspenseQuery>;
export type AuditDifferencesQueryResult = Apollo.QueryResult<AuditDifferencesQuery, AuditDifferencesQueryVariables>;
export const CompareAuditByIdDocument = gql`
    query CompareAuditById($id: ID!) {
  compareAuditById(id: $id) {
    auditId
    type
    resourceId
    comparedWith
    previousAuditId
    changes
  }
}
    `;

/**
 * __useCompareAuditByIdQuery__
 *
 * To run a query within a React component, call `useCompareAuditByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompareAuditByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompareAuditByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompareAuditByIdQuery(baseOptions: Apollo.QueryHookOptions<CompareAuditByIdQuery, CompareAuditByIdQueryVariables> & ({ variables: CompareAuditByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompareAuditByIdQuery, CompareAuditByIdQueryVariables>(CompareAuditByIdDocument, options);
      }
export function useCompareAuditByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompareAuditByIdQuery, CompareAuditByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompareAuditByIdQuery, CompareAuditByIdQueryVariables>(CompareAuditByIdDocument, options);
        }
// @ts-ignore
export function useCompareAuditByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompareAuditByIdQuery, CompareAuditByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CompareAuditByIdQuery, CompareAuditByIdQueryVariables>;
export function useCompareAuditByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompareAuditByIdQuery, CompareAuditByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CompareAuditByIdQuery | undefined, CompareAuditByIdQueryVariables>;
export function useCompareAuditByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompareAuditByIdQuery, CompareAuditByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompareAuditByIdQuery, CompareAuditByIdQueryVariables>(CompareAuditByIdDocument, options);
        }
export type CompareAuditByIdQueryHookResult = ReturnType<typeof useCompareAuditByIdQuery>;
export type CompareAuditByIdLazyQueryHookResult = ReturnType<typeof useCompareAuditByIdLazyQuery>;
export type CompareAuditByIdSuspenseQueryHookResult = ReturnType<typeof useCompareAuditByIdSuspenseQuery>;
export type CompareAuditByIdQueryResult = Apollo.QueryResult<CompareAuditByIdQuery, CompareAuditByIdQueryVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    message
    userData {
      _id
      email
      roles
      companyId
      profile {
        firstName
        lastName
      }
      state
      lastSeen
      metadata {
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    message
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RequestResetPasswordDocument = gql`
    mutation RequestResetPassword($input: RequestResetPasswordInput!) {
  requestResetPassword(input: $input)
}
    `;
export type RequestResetPasswordMutationFn = Apollo.MutationFunction<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>(RequestResetPasswordDocument, options);
      }
export type RequestResetPasswordMutationHookResult = ReturnType<typeof useRequestResetPasswordMutation>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<RequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    _id
    email
    profile {
      firstName
      lastName
    }
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ChangeOwnPasswordDocument = gql`
    mutation ChangeOwnPassword($input: ChangeOwnPasswordInput!) {
  changeOwnPassword(input: $input)
}
    `;
export type ChangeOwnPasswordMutationFn = Apollo.MutationFunction<ChangeOwnPasswordMutation, ChangeOwnPasswordMutationVariables>;

/**
 * __useChangeOwnPasswordMutation__
 *
 * To run a mutation, you first call `useChangeOwnPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOwnPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOwnPasswordMutation, { data, loading, error }] = useChangeOwnPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeOwnPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOwnPasswordMutation, ChangeOwnPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeOwnPasswordMutation, ChangeOwnPasswordMutationVariables>(ChangeOwnPasswordDocument, options);
      }
export type ChangeOwnPasswordMutationHookResult = ReturnType<typeof useChangeOwnPasswordMutation>;
export type ChangeOwnPasswordMutationResult = Apollo.MutationResult<ChangeOwnPasswordMutation>;
export type ChangeOwnPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeOwnPasswordMutation, ChangeOwnPasswordMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($input: VerifyEmailInput!) {
  verifyEmail(input: $input) {
    success
    message
    user {
      id
      email
      state
    }
  }
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const RestrictCommentVisibilityDocument = gql`
    mutation RestrictCommentVisibility($input: RestrictCommentInput!) {
  restrictCommentVisibility(input: $input) {
    id
    comment
    projectId
    userId
    userName
    service_name
    index
    parentCommentId
    targetRoles
    targetUsers
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;
export type RestrictCommentVisibilityMutationFn = Apollo.MutationFunction<RestrictCommentVisibilityMutation, RestrictCommentVisibilityMutationVariables>;

/**
 * __useRestrictCommentVisibilityMutation__
 *
 * To run a mutation, you first call `useRestrictCommentVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestrictCommentVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restrictCommentVisibilityMutation, { data, loading, error }] = useRestrictCommentVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestrictCommentVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<RestrictCommentVisibilityMutation, RestrictCommentVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestrictCommentVisibilityMutation, RestrictCommentVisibilityMutationVariables>(RestrictCommentVisibilityDocument, options);
      }
export type RestrictCommentVisibilityMutationHookResult = ReturnType<typeof useRestrictCommentVisibilityMutation>;
export type RestrictCommentVisibilityMutationResult = Apollo.MutationResult<RestrictCommentVisibilityMutation>;
export type RestrictCommentVisibilityMutationOptions = Apollo.BaseMutationOptions<RestrictCommentVisibilityMutation, RestrictCommentVisibilityMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    id
    comment
    projectId
    userId
    userName
    service_name
    index
    parentCommentId
    targetRoles
    targetUsers
    attachments
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const ReplyToCommentDocument = gql`
    mutation ReplyToComment($input: CreateReplyInput!) {
  replyToComment(input: $input) {
    id
    comment
    projectId
    userId
    userName
    service_name
    index
    parentCommentId
    targetRoles
    targetUsers
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;
export type ReplyToCommentMutationFn = Apollo.MutationFunction<ReplyToCommentMutation, ReplyToCommentMutationVariables>;

/**
 * __useReplyToCommentMutation__
 *
 * To run a mutation, you first call `useReplyToCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyToCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyToCommentMutation, { data, loading, error }] = useReplyToCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplyToCommentMutation(baseOptions?: Apollo.MutationHookOptions<ReplyToCommentMutation, ReplyToCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplyToCommentMutation, ReplyToCommentMutationVariables>(ReplyToCommentDocument, options);
      }
export type ReplyToCommentMutationHookResult = ReturnType<typeof useReplyToCommentMutation>;
export type ReplyToCommentMutationResult = Apollo.MutationResult<ReplyToCommentMutation>;
export type ReplyToCommentMutationOptions = Apollo.BaseMutationOptions<ReplyToCommentMutation, ReplyToCommentMutationVariables>;
export const ForwardCommentDocument = gql`
    mutation ForwardComment($input: ForwardCommentInput!) {
  forwardComment(input: $input) {
    id
    comment
    projectId
    userId
    userName
    service_name
    index
    parentCommentId
    targetRoles
    targetUsers
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;
export type ForwardCommentMutationFn = Apollo.MutationFunction<ForwardCommentMutation, ForwardCommentMutationVariables>;

/**
 * __useForwardCommentMutation__
 *
 * To run a mutation, you first call `useForwardCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForwardCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forwardCommentMutation, { data, loading, error }] = useForwardCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForwardCommentMutation(baseOptions?: Apollo.MutationHookOptions<ForwardCommentMutation, ForwardCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForwardCommentMutation, ForwardCommentMutationVariables>(ForwardCommentDocument, options);
      }
export type ForwardCommentMutationHookResult = ReturnType<typeof useForwardCommentMutation>;
export type ForwardCommentMutationResult = Apollo.MutationResult<ForwardCommentMutation>;
export type ForwardCommentMutationOptions = Apollo.BaseMutationOptions<ForwardCommentMutation, ForwardCommentMutationVariables>;
export const GetUserCommentsDocument = gql`
    query GetUserComments($id: ID!) {
  getUserComments(id: $id) {
    id
    comment
    projectId
    userId
    userName
    service_name
    index
    parentCommentId
    targetRoles
    targetUsers
    attachments
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetUserCommentsQuery__
 *
 * To run a query within a React component, call `useGetUserCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetUserCommentsQuery, GetUserCommentsQueryVariables> & ({ variables: GetUserCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCommentsQuery, GetUserCommentsQueryVariables>(GetUserCommentsDocument, options);
      }
export function useGetUserCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCommentsQuery, GetUserCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCommentsQuery, GetUserCommentsQueryVariables>(GetUserCommentsDocument, options);
        }
// @ts-ignore
export function useGetUserCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserCommentsQuery, GetUserCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserCommentsQuery, GetUserCommentsQueryVariables>;
export function useGetUserCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCommentsQuery, GetUserCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserCommentsQuery | undefined, GetUserCommentsQueryVariables>;
export function useGetUserCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCommentsQuery, GetUserCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserCommentsQuery, GetUserCommentsQueryVariables>(GetUserCommentsDocument, options);
        }
export type GetUserCommentsQueryHookResult = ReturnType<typeof useGetUserCommentsQuery>;
export type GetUserCommentsLazyQueryHookResult = ReturnType<typeof useGetUserCommentsLazyQuery>;
export type GetUserCommentsSuspenseQueryHookResult = ReturnType<typeof useGetUserCommentsSuspenseQuery>;
export type GetUserCommentsQueryResult = Apollo.QueryResult<GetUserCommentsQuery, GetUserCommentsQueryVariables>;
export const AllCommentsDocument = gql`
    query AllComments($projectId: ID!, $serviceName: String!, $index: String!) {
  allComments(projectId: $projectId, serviceName: $serviceName, index: $index) {
    id
    comment
    projectId
    userId
    userName
    service_name
    index
    parentCommentId
    targetRoles
    targetUsers
    attachments
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useAllCommentsQuery__
 *
 * To run a query within a React component, call `useAllCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCommentsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      serviceName: // value for 'serviceName'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useAllCommentsQuery(baseOptions: Apollo.QueryHookOptions<AllCommentsQuery, AllCommentsQueryVariables> & ({ variables: AllCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCommentsQuery, AllCommentsQueryVariables>(AllCommentsDocument, options);
      }
export function useAllCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCommentsQuery, AllCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCommentsQuery, AllCommentsQueryVariables>(AllCommentsDocument, options);
        }
// @ts-ignore
export function useAllCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCommentsQuery, AllCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<AllCommentsQuery, AllCommentsQueryVariables>;
export function useAllCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCommentsQuery, AllCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<AllCommentsQuery | undefined, AllCommentsQueryVariables>;
export function useAllCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCommentsQuery, AllCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCommentsQuery, AllCommentsQueryVariables>(AllCommentsDocument, options);
        }
export type AllCommentsQueryHookResult = ReturnType<typeof useAllCommentsQuery>;
export type AllCommentsLazyQueryHookResult = ReturnType<typeof useAllCommentsLazyQuery>;
export type AllCommentsSuspenseQueryHookResult = ReturnType<typeof useAllCommentsSuspenseQuery>;
export type AllCommentsQueryResult = Apollo.QueryResult<AllCommentsQuery, AllCommentsQueryVariables>;
export const RecentCommentsDocument = gql`
    query RecentComments($limit: Int, $offset: Int, $search: String, $serviceName: String, $stage: String) {
  recentComments(
    limit: $limit
    offset: $offset
    search: $search
    serviceName: $serviceName
    stage: $stage
  ) {
    total
    stages {
      service_name
      serviceLabel
      index
      name
    }
    items {
      id
      comment
      projectId
      projectTitle
      userId
      userName
      service_name
      index
      stageName
      parentCommentId
      forward
      targetRoles
      targetUsers
      attachments
      metadata {
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useRecentCommentsQuery__
 *
 * To run a query within a React component, call `useRecentCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentCommentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      serviceName: // value for 'serviceName'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useRecentCommentsQuery(baseOptions?: Apollo.QueryHookOptions<RecentCommentsQuery, RecentCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentCommentsQuery, RecentCommentsQueryVariables>(RecentCommentsDocument, options);
      }
export function useRecentCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentCommentsQuery, RecentCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentCommentsQuery, RecentCommentsQueryVariables>(RecentCommentsDocument, options);
        }
// @ts-ignore
export function useRecentCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentCommentsQuery, RecentCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentCommentsQuery, RecentCommentsQueryVariables>;
export function useRecentCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentCommentsQuery, RecentCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentCommentsQuery | undefined, RecentCommentsQueryVariables>;
export function useRecentCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentCommentsQuery, RecentCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentCommentsQuery, RecentCommentsQueryVariables>(RecentCommentsDocument, options);
        }
export type RecentCommentsQueryHookResult = ReturnType<typeof useRecentCommentsQuery>;
export type RecentCommentsLazyQueryHookResult = ReturnType<typeof useRecentCommentsLazyQuery>;
export type RecentCommentsSuspenseQueryHookResult = ReturnType<typeof useRecentCommentsSuspenseQuery>;
export type RecentCommentsQueryResult = Apollo.QueryResult<RecentCommentsQuery, RecentCommentsQueryVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    message
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const AllCompaniesDocument = gql`
    query AllCompanies {
  allCompanies {
    id
    companyName
    state
    ownerId
  }
}
    `;

/**
 * __useAllCompaniesQuery__
 *
 * To run a query within a React component, call `useAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
      }
export function useAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
        }
// @ts-ignore
export function useAllCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<AllCompaniesQuery, AllCompaniesQueryVariables>;
export function useAllCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<AllCompaniesQuery | undefined, AllCompaniesQueryVariables>;
export function useAllCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
        }
export type AllCompaniesQueryHookResult = ReturnType<typeof useAllCompaniesQuery>;
export type AllCompaniesLazyQueryHookResult = ReturnType<typeof useAllCompaniesLazyQuery>;
export type AllCompaniesSuspenseQueryHookResult = ReturnType<typeof useAllCompaniesSuspenseQuery>;
export type AllCompaniesQueryResult = Apollo.QueryResult<AllCompaniesQuery, AllCompaniesQueryVariables>;
export const CompanyByIdDocument = gql`
    query CompanyById($id: ID!) {
  companyById(id: $id) {
    id
    companyName
    state
    ownerId
  }
}
    `;

/**
 * __useCompanyByIdQuery__
 *
 * To run a query within a React component, call `useCompanyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyByIdQuery(baseOptions: Apollo.QueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables> & ({ variables: CompanyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyByIdQuery, CompanyByIdQueryVariables>(CompanyByIdDocument, options);
      }
export function useCompanyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyByIdQuery, CompanyByIdQueryVariables>(CompanyByIdDocument, options);
        }
// @ts-ignore
export function useCompanyByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyByIdQuery, CompanyByIdQueryVariables>;
export function useCompanyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyByIdQuery | undefined, CompanyByIdQueryVariables>;
export function useCompanyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyByIdQuery, CompanyByIdQueryVariables>(CompanyByIdDocument, options);
        }
export type CompanyByIdQueryHookResult = ReturnType<typeof useCompanyByIdQuery>;
export type CompanyByIdLazyQueryHookResult = ReturnType<typeof useCompanyByIdLazyQuery>;
export type CompanyByIdSuspenseQueryHookResult = ReturnType<typeof useCompanyByIdSuspenseQuery>;
export type CompanyByIdQueryResult = Apollo.QueryResult<CompanyByIdQuery, CompanyByIdQueryVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($id: ID!) {
  deleteFile(id: $id) {
    success
    message
  }
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const AllFilesDocument = gql`
    query AllFiles($projectId: ID!, $selection: String, $pagination: PaginationInput) {
  allFiles(projectId: $projectId, selection: $selection, pagination: $pagination) {
    files {
      id
      name
      status
      state
      physical_name
      projectId
      serviceId
      ownerId
      size
      type
      isDeleted
      geojson_table
      geojson_import_error
      geojson_import_status
      metadata {
        createdAt
        updatedAt
      }
    }
    pagination {
      page
      limit
      maxLimit
      sort
      order
      count
    }
  }
}
    `;

/**
 * __useAllFilesQuery__
 *
 * To run a query within a React component, call `useAllFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFilesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      selection: // value for 'selection'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllFilesQuery(baseOptions: Apollo.QueryHookOptions<AllFilesQuery, AllFilesQueryVariables> & ({ variables: AllFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFilesQuery, AllFilesQueryVariables>(AllFilesDocument, options);
      }
export function useAllFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFilesQuery, AllFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFilesQuery, AllFilesQueryVariables>(AllFilesDocument, options);
        }
// @ts-ignore
export function useAllFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllFilesQuery, AllFilesQueryVariables>): Apollo.UseSuspenseQueryResult<AllFilesQuery, AllFilesQueryVariables>;
export function useAllFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllFilesQuery, AllFilesQueryVariables>): Apollo.UseSuspenseQueryResult<AllFilesQuery | undefined, AllFilesQueryVariables>;
export function useAllFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllFilesQuery, AllFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllFilesQuery, AllFilesQueryVariables>(AllFilesDocument, options);
        }
export type AllFilesQueryHookResult = ReturnType<typeof useAllFilesQuery>;
export type AllFilesLazyQueryHookResult = ReturnType<typeof useAllFilesLazyQuery>;
export type AllFilesSuspenseQueryHookResult = ReturnType<typeof useAllFilesSuspenseQuery>;
export type AllFilesQueryResult = Apollo.QueryResult<AllFilesQuery, AllFilesQueryVariables>;
export const FilesByProjectStateDocument = gql`
    query FilesByProjectState($projectId: ID!, $state: String!) {
  filesByProjectState(projectId: $projectId, state: $state) {
    files {
      id
      name
      physical_name
      projectId
      serviceId
      ownerId
      state
      size
      type
      status
      isDeleted
      geojson_table
      geojson_import_error
      geojson_import_status
      metadata {
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useFilesByProjectStateQuery__
 *
 * To run a query within a React component, call `useFilesByProjectStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesByProjectStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesByProjectStateQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useFilesByProjectStateQuery(baseOptions: Apollo.QueryHookOptions<FilesByProjectStateQuery, FilesByProjectStateQueryVariables> & ({ variables: FilesByProjectStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilesByProjectStateQuery, FilesByProjectStateQueryVariables>(FilesByProjectStateDocument, options);
      }
export function useFilesByProjectStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilesByProjectStateQuery, FilesByProjectStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilesByProjectStateQuery, FilesByProjectStateQueryVariables>(FilesByProjectStateDocument, options);
        }
// @ts-ignore
export function useFilesByProjectStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FilesByProjectStateQuery, FilesByProjectStateQueryVariables>): Apollo.UseSuspenseQueryResult<FilesByProjectStateQuery, FilesByProjectStateQueryVariables>;
export function useFilesByProjectStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilesByProjectStateQuery, FilesByProjectStateQueryVariables>): Apollo.UseSuspenseQueryResult<FilesByProjectStateQuery | undefined, FilesByProjectStateQueryVariables>;
export function useFilesByProjectStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilesByProjectStateQuery, FilesByProjectStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilesByProjectStateQuery, FilesByProjectStateQueryVariables>(FilesByProjectStateDocument, options);
        }
export type FilesByProjectStateQueryHookResult = ReturnType<typeof useFilesByProjectStateQuery>;
export type FilesByProjectStateLazyQueryHookResult = ReturnType<typeof useFilesByProjectStateLazyQuery>;
export type FilesByProjectStateSuspenseQueryHookResult = ReturnType<typeof useFilesByProjectStateSuspenseQuery>;
export type FilesByProjectStateQueryResult = Apollo.QueryResult<FilesByProjectStateQuery, FilesByProjectStateQueryVariables>;
export const ReadFileAsGeoJsonDocument = gql`
    query ReadFileAsGeoJSON($fileId: ID!) {
  readFileAsGeoJSON(fileId: $fileId) {
    type
    geometry {
      type
      coordinates
    }
    properties {
      name
      fileId
    }
  }
}
    `;

/**
 * __useReadFileAsGeoJsonQuery__
 *
 * To run a query within a React component, call `useReadFileAsGeoJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadFileAsGeoJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadFileAsGeoJsonQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useReadFileAsGeoJsonQuery(baseOptions: Apollo.QueryHookOptions<ReadFileAsGeoJsonQuery, ReadFileAsGeoJsonQueryVariables> & ({ variables: ReadFileAsGeoJsonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadFileAsGeoJsonQuery, ReadFileAsGeoJsonQueryVariables>(ReadFileAsGeoJsonDocument, options);
      }
export function useReadFileAsGeoJsonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadFileAsGeoJsonQuery, ReadFileAsGeoJsonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadFileAsGeoJsonQuery, ReadFileAsGeoJsonQueryVariables>(ReadFileAsGeoJsonDocument, options);
        }
// @ts-ignore
export function useReadFileAsGeoJsonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReadFileAsGeoJsonQuery, ReadFileAsGeoJsonQueryVariables>): Apollo.UseSuspenseQueryResult<ReadFileAsGeoJsonQuery, ReadFileAsGeoJsonQueryVariables>;
export function useReadFileAsGeoJsonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadFileAsGeoJsonQuery, ReadFileAsGeoJsonQueryVariables>): Apollo.UseSuspenseQueryResult<ReadFileAsGeoJsonQuery | undefined, ReadFileAsGeoJsonQueryVariables>;
export function useReadFileAsGeoJsonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadFileAsGeoJsonQuery, ReadFileAsGeoJsonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadFileAsGeoJsonQuery, ReadFileAsGeoJsonQueryVariables>(ReadFileAsGeoJsonDocument, options);
        }
export type ReadFileAsGeoJsonQueryHookResult = ReturnType<typeof useReadFileAsGeoJsonQuery>;
export type ReadFileAsGeoJsonLazyQueryHookResult = ReturnType<typeof useReadFileAsGeoJsonLazyQuery>;
export type ReadFileAsGeoJsonSuspenseQueryHookResult = ReturnType<typeof useReadFileAsGeoJsonSuspenseQuery>;
export type ReadFileAsGeoJsonQueryResult = Apollo.QueryResult<ReadFileAsGeoJsonQuery, ReadFileAsGeoJsonQueryVariables>;
export const FileUpdatesDocument = gql`
    subscription FileUpdates($fileId: ID!) {
  fileUpdates(fileId: $fileId) {
    fileId
  }
}
    `;

/**
 * __useFileUpdatesSubscription__
 *
 * To run a query within a React component, call `useFileUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFileUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileUpdatesSubscription({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useFileUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<FileUpdatesSubscription, FileUpdatesSubscriptionVariables> & ({ variables: FileUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<FileUpdatesSubscription, FileUpdatesSubscriptionVariables>(FileUpdatesDocument, options);
      }
export type FileUpdatesSubscriptionHookResult = ReturnType<typeof useFileUpdatesSubscription>;
export type FileUpdatesSubscriptionResult = Apollo.SubscriptionResult<FileUpdatesSubscription>;
export const MarkContactMessageAsReadDocument = gql`
    mutation MarkContactMessageAsRead($input: MarkAsReadInput!) {
  markContactMessageAsRead(input: $input) {
    id
    read {
      readDate
      readUser
    }
  }
}
    `;
export type MarkContactMessageAsReadMutationFn = Apollo.MutationFunction<MarkContactMessageAsReadMutation, MarkContactMessageAsReadMutationVariables>;

/**
 * __useMarkContactMessageAsReadMutation__
 *
 * To run a mutation, you first call `useMarkContactMessageAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkContactMessageAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markContactMessageAsReadMutation, { data, loading, error }] = useMarkContactMessageAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkContactMessageAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkContactMessageAsReadMutation, MarkContactMessageAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkContactMessageAsReadMutation, MarkContactMessageAsReadMutationVariables>(MarkContactMessageAsReadDocument, options);
      }
export type MarkContactMessageAsReadMutationHookResult = ReturnType<typeof useMarkContactMessageAsReadMutation>;
export type MarkContactMessageAsReadMutationResult = Apollo.MutationResult<MarkContactMessageAsReadMutation>;
export type MarkContactMessageAsReadMutationOptions = Apollo.BaseMutationOptions<MarkContactMessageAsReadMutation, MarkContactMessageAsReadMutationVariables>;
export const SendContactMessageDocument = gql`
    mutation SendContactMessage($input: SendContactMessageInput!) {
  sendContactMessage(input: $input) {
    id
    name
    email
    company
    message
    title
    phone
    read {
      readDate
      readUser
    }
    metadata {
      createdAt
    }
  }
}
    `;
export type SendContactMessageMutationFn = Apollo.MutationFunction<SendContactMessageMutation, SendContactMessageMutationVariables>;

/**
 * __useSendContactMessageMutation__
 *
 * To run a mutation, you first call `useSendContactMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactMessageMutation, { data, loading, error }] = useSendContactMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendContactMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendContactMessageMutation, SendContactMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContactMessageMutation, SendContactMessageMutationVariables>(SendContactMessageDocument, options);
      }
export type SendContactMessageMutationHookResult = ReturnType<typeof useSendContactMessageMutation>;
export type SendContactMessageMutationResult = Apollo.MutationResult<SendContactMessageMutation>;
export type SendContactMessageMutationOptions = Apollo.BaseMutationOptions<SendContactMessageMutation, SendContactMessageMutationVariables>;
export const AllContactMessagesDocument = gql`
    query AllContactMessages($pagination: PaginationInput) {
  allContactMessages(pagination: $pagination) {
    messages {
      id
      name
      email
      company
      message
      title
      phone
      ip
      read {
        readDate
        readUser
      }
      metadata {
        createdAt
        updatedAt
      }
    }
    pagination {
      page
      limit
      maxLimit
      count
    }
  }
}
    `;

/**
 * __useAllContactMessagesQuery__
 *
 * To run a query within a React component, call `useAllContactMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllContactMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllContactMessagesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllContactMessagesQuery(baseOptions?: Apollo.QueryHookOptions<AllContactMessagesQuery, AllContactMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllContactMessagesQuery, AllContactMessagesQueryVariables>(AllContactMessagesDocument, options);
      }
export function useAllContactMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllContactMessagesQuery, AllContactMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllContactMessagesQuery, AllContactMessagesQueryVariables>(AllContactMessagesDocument, options);
        }
// @ts-ignore
export function useAllContactMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllContactMessagesQuery, AllContactMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<AllContactMessagesQuery, AllContactMessagesQueryVariables>;
export function useAllContactMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllContactMessagesQuery, AllContactMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<AllContactMessagesQuery | undefined, AllContactMessagesQueryVariables>;
export function useAllContactMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllContactMessagesQuery, AllContactMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllContactMessagesQuery, AllContactMessagesQueryVariables>(AllContactMessagesDocument, options);
        }
export type AllContactMessagesQueryHookResult = ReturnType<typeof useAllContactMessagesQuery>;
export type AllContactMessagesLazyQueryHookResult = ReturnType<typeof useAllContactMessagesLazyQuery>;
export type AllContactMessagesSuspenseQueryHookResult = ReturnType<typeof useAllContactMessagesSuspenseQuery>;
export type AllContactMessagesQueryResult = Apollo.QueryResult<AllContactMessagesQuery, AllContactMessagesQueryVariables>;
export const ContactMessageByIdDocument = gql`
    query ContactMessageById($id: ID!) {
  contactMessageById(id: $id) {
    id
    name
    email
    company
    message
    title
    phone
    ip
    read {
      readDate
      readUser
    }
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useContactMessageByIdQuery__
 *
 * To run a query within a React component, call `useContactMessageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactMessageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactMessageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactMessageByIdQuery(baseOptions: Apollo.QueryHookOptions<ContactMessageByIdQuery, ContactMessageByIdQueryVariables> & ({ variables: ContactMessageByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactMessageByIdQuery, ContactMessageByIdQueryVariables>(ContactMessageByIdDocument, options);
      }
export function useContactMessageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactMessageByIdQuery, ContactMessageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactMessageByIdQuery, ContactMessageByIdQueryVariables>(ContactMessageByIdDocument, options);
        }
// @ts-ignore
export function useContactMessageByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactMessageByIdQuery, ContactMessageByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ContactMessageByIdQuery, ContactMessageByIdQueryVariables>;
export function useContactMessageByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactMessageByIdQuery, ContactMessageByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ContactMessageByIdQuery | undefined, ContactMessageByIdQueryVariables>;
export function useContactMessageByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactMessageByIdQuery, ContactMessageByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactMessageByIdQuery, ContactMessageByIdQueryVariables>(ContactMessageByIdDocument, options);
        }
export type ContactMessageByIdQueryHookResult = ReturnType<typeof useContactMessageByIdQuery>;
export type ContactMessageByIdLazyQueryHookResult = ReturnType<typeof useContactMessageByIdLazyQuery>;
export type ContactMessageByIdSuspenseQueryHookResult = ReturnType<typeof useContactMessageByIdSuspenseQuery>;
export type ContactMessageByIdQueryResult = Apollo.QueryResult<ContactMessageByIdQuery, ContactMessageByIdQueryVariables>;
export const SetNotificationSeenDocument = gql`
    mutation SetNotificationSeen($notificationId: ID!) {
  setNotificationSeen(notificationId: $notificationId) {
    id
    roles
    users
    timeToLive
    seenTimeToLive
    seen
    title
    body
    every_one
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;
export type SetNotificationSeenMutationFn = Apollo.MutationFunction<SetNotificationSeenMutation, SetNotificationSeenMutationVariables>;

/**
 * __useSetNotificationSeenMutation__
 *
 * To run a mutation, you first call `useSetNotificationSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationSeenMutation, { data, loading, error }] = useSetNotificationSeenMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useSetNotificationSeenMutation(baseOptions?: Apollo.MutationHookOptions<SetNotificationSeenMutation, SetNotificationSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNotificationSeenMutation, SetNotificationSeenMutationVariables>(SetNotificationSeenDocument, options);
      }
export type SetNotificationSeenMutationHookResult = ReturnType<typeof useSetNotificationSeenMutation>;
export type SetNotificationSeenMutationResult = Apollo.MutationResult<SetNotificationSeenMutation>;
export type SetNotificationSeenMutationOptions = Apollo.BaseMutationOptions<SetNotificationSeenMutation, SetNotificationSeenMutationVariables>;
export const NotificationsDocument = gql`
    query Notifications($limit: Int, $offset: Int, $search: String, $unreadOnly: Boolean) {
  notifications(
    limit: $limit
    offset: $offset
    search: $search
    unreadOnly: $unreadOnly
  ) {
    items {
      id
      roles
      users
      timeToLive
      seenTimeToLive
      seen
      link
      title
      body
      every_one
      metadata {
        createdAt
        updatedAt
      }
    }
    total
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      unreadOnly: // value for 'unreadOnly'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
// @ts-ignore
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<NotificationsQuery, NotificationsQueryVariables>;
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<NotificationsQuery | undefined, NotificationsQueryVariables>;
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const UnreadNotificationsCountDocument = gql`
    query UnreadNotificationsCount {
  unreadNotificationsCount
}
    `;

/**
 * __useUnreadNotificationsCountQuery__
 *
 * To run a query within a React component, call `useUnreadNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadNotificationsCountQuery(baseOptions?: Apollo.QueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(UnreadNotificationsCountDocument, options);
      }
export function useUnreadNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(UnreadNotificationsCountDocument, options);
        }
// @ts-ignore
export function useUnreadNotificationsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>): Apollo.UseSuspenseQueryResult<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>;
export function useUnreadNotificationsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>): Apollo.UseSuspenseQueryResult<UnreadNotificationsCountQuery | undefined, UnreadNotificationsCountQueryVariables>;
export function useUnreadNotificationsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(UnreadNotificationsCountDocument, options);
        }
export type UnreadNotificationsCountQueryHookResult = ReturnType<typeof useUnreadNotificationsCountQuery>;
export type UnreadNotificationsCountLazyQueryHookResult = ReturnType<typeof useUnreadNotificationsCountLazyQuery>;
export type UnreadNotificationsCountSuspenseQueryHookResult = ReturnType<typeof useUnreadNotificationsCountSuspenseQuery>;
export type UnreadNotificationsCountQueryResult = Apollo.QueryResult<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>;
export const UserNotificationSubscriptionDocument = gql`
    subscription UserNotificationSubscription {
  userNotification {
    id
    title
    body
    link
    seen
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useUserNotificationSubscriptionSubscription__
 *
 * To run a query within a React component, call `useUserNotificationSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserNotificationSubscriptionSubscription, UserNotificationSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserNotificationSubscriptionSubscription, UserNotificationSubscriptionSubscriptionVariables>(UserNotificationSubscriptionDocument, options);
      }
export type UserNotificationSubscriptionSubscriptionHookResult = ReturnType<typeof useUserNotificationSubscriptionSubscription>;
export type UserNotificationSubscriptionSubscriptionResult = Apollo.SubscriptionResult<UserNotificationSubscriptionSubscription>;
export const CreateProjectDocument = gql`
    mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
    title
    description
    status
    companyId
    assignedTo
    ownerId
    isDeleted
    service {
      serviceId
      serviceName
      status
      notes
      workflow_version
      current_state
      prev_state
      scheduledDate
    }
    data {
      state
      data {
        priority
        dataSource
        gcpSource
        analysisLevel
        gsdAccuracyProfile
        deliverables {
          category
          options
          outputFormats
        }
        gsd
        flightAltitude
        sensor
        potentialRisks
        technicalQualityChecklist {
          imageResolutionMet
          completeSiteCoverageVerified
          noMissingOrCorruptedFiles
          thermalCalibrationDataPresent
          metadataGeolocationValid
          fileFormatCompatibilityConfirmed
        }
        pricingProposal {
          proposedPrice
          currency
        }
        missionDesign {
          numberOfMissions
          coverageAreaHectares
          estimatedFlightTimeHours
          flightDate
          flightDurationMinutes
          imageCount
        }
        imageUpload {
          numberOfImages
        }
        gcpUpload {
          coordinateSystem
          fileName
          pointCount
        }
        plant {
          plantType
          mountingType
          installedCapacityMW
        }
        module {
          manufacturer
          panelType
          width
          height
        }
      }
      files
      area
      drawnFeatures {
        type
        properties {
          name
        }
        geometry {
          type
          coordinates
        }
      }
    }
    timeline {
      startDate
      endDate
      estimatedDuration
    }
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: ID!, $input: UpdateProjectInput!) {
  updateProject(id: $id, input: $input) {
    id
    title
    description
    status
    companyId
    assignedTo
    ownerId
    isDeleted
    service {
      serviceId
      serviceName
      status
      notes
      workflow_version
      current_state
      prev_state
      scheduledDate
    }
    data {
      state
      data {
        priority
        dataSource
        gcpSource
        analysisLevel
        gsdAccuracyProfile
        deliverables {
          category
          options
          outputFormats
        }
        gsd
        flightAltitude
        sensor
        potentialRisks
        technicalQualityChecklist {
          imageResolutionMet
          completeSiteCoverageVerified
          noMissingOrCorruptedFiles
          thermalCalibrationDataPresent
          metadataGeolocationValid
          fileFormatCompatibilityConfirmed
        }
        pricingProposal {
          proposedPrice
          currency
        }
        missionDesign {
          numberOfMissions
          coverageAreaHectares
          estimatedFlightTimeHours
          flightDate
          flightDurationMinutes
          imageCount
        }
        imageUpload {
          numberOfImages
        }
        gcpUpload {
          coordinateSystem
          fileName
          pointCount
        }
        plant {
          plantType
          mountingType
          installedCapacityMW
        }
        module {
          manufacturer
          panelType
          width
          height
        }
      }
      files
      area
      drawnFeatures {
        type
        properties {
          name
        }
        geometry {
          type
          coordinates
        }
      }
    }
    timeline {
      startDate
      endDate
      estimatedDuration
    }
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateProjectStatusDocument = gql`
    mutation UpdateProjectStatus($id: ID!, $input: UpdateProjectStatusInput!) {
  updateProjectStatus(id: $id, input: $input) {
    id
    status
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateProjectStatusMutationFn = Apollo.MutationFunction<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;

/**
 * __useUpdateProjectStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProjectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectStatusMutation, { data, loading, error }] = useUpdateProjectStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>(UpdateProjectStatusDocument, options);
      }
export type UpdateProjectStatusMutationHookResult = ReturnType<typeof useUpdateProjectStatusMutation>;
export type UpdateProjectStatusMutationResult = Apollo.MutationResult<UpdateProjectStatusMutation>;
export type UpdateProjectStatusMutationOptions = Apollo.BaseMutationOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id) {
    success
    message
  }
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const UpdateProjectAssignedToDocument = gql`
    mutation UpdateProjectAssignedTo($id: ID!, $comment: String) {
  updateProjectAssignedTo(id: $id, comment: $comment) {
    id
    assignedTo
    ownerId
    metadata {
      updatedAt
    }
  }
}
    `;
export type UpdateProjectAssignedToMutationFn = Apollo.MutationFunction<UpdateProjectAssignedToMutation, UpdateProjectAssignedToMutationVariables>;

/**
 * __useUpdateProjectAssignedToMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAssignedToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAssignedToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAssignedToMutation, { data, loading, error }] = useUpdateProjectAssignedToMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateProjectAssignedToMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectAssignedToMutation, UpdateProjectAssignedToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectAssignedToMutation, UpdateProjectAssignedToMutationVariables>(UpdateProjectAssignedToDocument, options);
      }
export type UpdateProjectAssignedToMutationHookResult = ReturnType<typeof useUpdateProjectAssignedToMutation>;
export type UpdateProjectAssignedToMutationResult = Apollo.MutationResult<UpdateProjectAssignedToMutation>;
export type UpdateProjectAssignedToMutationOptions = Apollo.BaseMutationOptions<UpdateProjectAssignedToMutation, UpdateProjectAssignedToMutationVariables>;
export const AllProjectsDocument = gql`
    query AllProjects($search: String, $status: ProjectStatus, $assignment: ProjectAssignment, $pagination: PaginationInput) {
  allProjects(
    search: $search
    status: $status
    assignment: $assignment
    pagination: $pagination
  ) {
    projects {
      id
      title
      description
      status
      companyId
      assignedTo
      ownerId
      isDeleted
      priorityRank
      progress
      service {
        serviceName
        current_state
        current_state_started_at
        workflow_version
      }
      timeline {
        startDate
        endDate
        estimatedDuration
      }
      metadata {
        createdAt
        updatedAt
      }
    }
    pagination {
      page
      limit
      maxLimit
      sort
      order
      count
    }
  }
}
    `;

/**
 * __useAllProjectsQuery__
 *
 * To run a query within a React component, call `useAllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProjectsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      assignment: // value for 'assignment'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllProjectsQuery(baseOptions?: Apollo.QueryHookOptions<AllProjectsQuery, AllProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProjectsQuery, AllProjectsQueryVariables>(AllProjectsDocument, options);
      }
export function useAllProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProjectsQuery, AllProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProjectsQuery, AllProjectsQueryVariables>(AllProjectsDocument, options);
        }
// @ts-ignore
export function useAllProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllProjectsQuery, AllProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<AllProjectsQuery, AllProjectsQueryVariables>;
export function useAllProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllProjectsQuery, AllProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<AllProjectsQuery | undefined, AllProjectsQueryVariables>;
export function useAllProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllProjectsQuery, AllProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllProjectsQuery, AllProjectsQueryVariables>(AllProjectsDocument, options);
        }
export type AllProjectsQueryHookResult = ReturnType<typeof useAllProjectsQuery>;
export type AllProjectsLazyQueryHookResult = ReturnType<typeof useAllProjectsLazyQuery>;
export type AllProjectsSuspenseQueryHookResult = ReturnType<typeof useAllProjectsSuspenseQuery>;
export type AllProjectsQueryResult = Apollo.QueryResult<AllProjectsQuery, AllProjectsQueryVariables>;
export const ProjectStatusCountsDocument = gql`
    query ProjectStatusCounts {
  projectStatusCounts {
    total
    counts {
      status
      count
    }
  }
}
    `;

/**
 * __useProjectStatusCountsQuery__
 *
 * To run a query within a React component, call `useProjectStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectStatusCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectStatusCountsQuery, ProjectStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectStatusCountsQuery, ProjectStatusCountsQueryVariables>(ProjectStatusCountsDocument, options);
      }
export function useProjectStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectStatusCountsQuery, ProjectStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectStatusCountsQuery, ProjectStatusCountsQueryVariables>(ProjectStatusCountsDocument, options);
        }
// @ts-ignore
export function useProjectStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectStatusCountsQuery, ProjectStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectStatusCountsQuery, ProjectStatusCountsQueryVariables>;
export function useProjectStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectStatusCountsQuery, ProjectStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectStatusCountsQuery | undefined, ProjectStatusCountsQueryVariables>;
export function useProjectStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectStatusCountsQuery, ProjectStatusCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectStatusCountsQuery, ProjectStatusCountsQueryVariables>(ProjectStatusCountsDocument, options);
        }
export type ProjectStatusCountsQueryHookResult = ReturnType<typeof useProjectStatusCountsQuery>;
export type ProjectStatusCountsLazyQueryHookResult = ReturnType<typeof useProjectStatusCountsLazyQuery>;
export type ProjectStatusCountsSuspenseQueryHookResult = ReturnType<typeof useProjectStatusCountsSuspenseQuery>;
export type ProjectStatusCountsQueryResult = Apollo.QueryResult<ProjectStatusCountsQuery, ProjectStatusCountsQueryVariables>;
export const ProjectByIdDocument = gql`
    query ProjectById($id: ID!) {
  projectById(id: $id) {
    id
    title
    description
    status
    companyId
    assignedTo
    ownerId
    isDeleted
    service {
      serviceId
      serviceName
      status
      notes
      workflow_version
      current_state
      prev_state
      scheduledDate
    }
    data {
      state
      data {
        priority
        dataSource
        gcpSource
        analysisLevel
        gsdAccuracyProfile
        deliverables {
          category
          options
          outputFormats
        }
        gsd
        flightAltitude
        sensor
        potentialRisks
        technicalQualityChecklist {
          imageResolutionMet
          completeSiteCoverageVerified
          noMissingOrCorruptedFiles
          thermalCalibrationDataPresent
          metadataGeolocationValid
          fileFormatCompatibilityConfirmed
        }
        pricingProposal {
          proposedPrice
          currency
        }
        missionDesign {
          numberOfMissions
          coverageAreaHectares
          estimatedFlightTimeHours
          flightDate
          flightDurationMinutes
          imageCount
        }
        imageUpload {
          numberOfImages
        }
        gcpUpload {
          coordinateSystem
          fileName
          pointCount
        }
        plant {
          plantType
          mountingType
          installedCapacityMW
        }
        module {
          manufacturer
          panelType
          width
          height
        }
      }
      files
      area
    }
    timeline {
      startDate
      endDate
      estimatedDuration
    }
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useProjectByIdQuery__
 *
 * To run a query within a React component, call `useProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables> & ({ variables: ProjectByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
      }
export function useProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
        }
// @ts-ignore
export function useProjectByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectByIdQuery, ProjectByIdQueryVariables>;
export function useProjectByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectByIdQuery | undefined, ProjectByIdQueryVariables>;
export function useProjectByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
        }
export type ProjectByIdQueryHookResult = ReturnType<typeof useProjectByIdQuery>;
export type ProjectByIdLazyQueryHookResult = ReturnType<typeof useProjectByIdLazyQuery>;
export type ProjectByIdSuspenseQueryHookResult = ReturnType<typeof useProjectByIdSuspenseQuery>;
export type ProjectByIdQueryResult = Apollo.QueryResult<ProjectByIdQuery, ProjectByIdQueryVariables>;
export const ProjectAssignmentChangedDocument = gql`
    subscription ProjectAssignmentChanged {
  projectAssignmentChanged {
    projectId
    changedAt
  }
}
    `;

/**
 * __useProjectAssignmentChangedSubscription__
 *
 * To run a query within a React component, call `useProjectAssignmentChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectAssignmentChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAssignmentChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectAssignmentChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ProjectAssignmentChangedSubscription, ProjectAssignmentChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProjectAssignmentChangedSubscription, ProjectAssignmentChangedSubscriptionVariables>(ProjectAssignmentChangedDocument, options);
      }
export type ProjectAssignmentChangedSubscriptionHookResult = ReturnType<typeof useProjectAssignmentChangedSubscription>;
export type ProjectAssignmentChangedSubscriptionResult = Apollo.SubscriptionResult<ProjectAssignmentChangedSubscription>;
export const AllServicesDocument = gql`
    query AllServices($selection: ServicesSelection) {
  allServices(selection: $selection) {
    id
    name
    description
    tags
    icon
    isDeleted
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAllServicesQuery__
 *
 * To run a query within a React component, call `useAllServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllServicesQuery({
 *   variables: {
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useAllServicesQuery(baseOptions?: Apollo.QueryHookOptions<AllServicesQuery, AllServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllServicesQuery, AllServicesQueryVariables>(AllServicesDocument, options);
      }
export function useAllServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllServicesQuery, AllServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllServicesQuery, AllServicesQueryVariables>(AllServicesDocument, options);
        }
// @ts-ignore
export function useAllServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllServicesQuery, AllServicesQueryVariables>): Apollo.UseSuspenseQueryResult<AllServicesQuery, AllServicesQueryVariables>;
export function useAllServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllServicesQuery, AllServicesQueryVariables>): Apollo.UseSuspenseQueryResult<AllServicesQuery | undefined, AllServicesQueryVariables>;
export function useAllServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllServicesQuery, AllServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllServicesQuery, AllServicesQueryVariables>(AllServicesDocument, options);
        }
export type AllServicesQueryHookResult = ReturnType<typeof useAllServicesQuery>;
export type AllServicesLazyQueryHookResult = ReturnType<typeof useAllServicesLazyQuery>;
export type AllServicesSuspenseQueryHookResult = ReturnType<typeof useAllServicesSuspenseQuery>;
export type AllServicesQueryResult = Apollo.QueryResult<AllServicesQuery, AllServicesQueryVariables>;
export const ServiceByIdDocument = gql`
    query ServiceById($id: ID!) {
  serviceById(id: $id) {
    id
    name
    description
    tags
    icon
    isDeleted
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useServiceByIdQuery__
 *
 * To run a query within a React component, call `useServiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceByIdQuery(baseOptions: Apollo.QueryHookOptions<ServiceByIdQuery, ServiceByIdQueryVariables> & ({ variables: ServiceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceByIdQuery, ServiceByIdQueryVariables>(ServiceByIdDocument, options);
      }
export function useServiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceByIdQuery, ServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceByIdQuery, ServiceByIdQueryVariables>(ServiceByIdDocument, options);
        }
// @ts-ignore
export function useServiceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceByIdQuery, ServiceByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ServiceByIdQuery, ServiceByIdQueryVariables>;
export function useServiceByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceByIdQuery, ServiceByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ServiceByIdQuery | undefined, ServiceByIdQueryVariables>;
export function useServiceByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceByIdQuery, ServiceByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceByIdQuery, ServiceByIdQueryVariables>(ServiceByIdDocument, options);
        }
export type ServiceByIdQueryHookResult = ReturnType<typeof useServiceByIdQuery>;
export type ServiceByIdLazyQueryHookResult = ReturnType<typeof useServiceByIdLazyQuery>;
export type ServiceByIdSuspenseQueryHookResult = ReturnType<typeof useServiceByIdSuspenseQuery>;
export type ServiceByIdQueryResult = Apollo.QueryResult<ServiceByIdQuery, ServiceByIdQueryVariables>;
export const UpdateSettingDocument = gql`
    mutation UpdateSetting($key: String!, $input: SettingUpdateInput!) {
  updateSetting(key: $key, input: $input) {
    key
    label
    value
    defaultValue
    type
    TTL
    description
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateSettingMutationFn = Apollo.MutationFunction<UpdateSettingMutation, UpdateSettingMutationVariables>;

/**
 * __useUpdateSettingMutation__
 *
 * To run a mutation, you first call `useUpdateSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingMutation, { data, loading, error }] = useUpdateSettingMutation({
 *   variables: {
 *      key: // value for 'key'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingMutation, UpdateSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingMutation, UpdateSettingMutationVariables>(UpdateSettingDocument, options);
      }
export type UpdateSettingMutationHookResult = ReturnType<typeof useUpdateSettingMutation>;
export type UpdateSettingMutationResult = Apollo.MutationResult<UpdateSettingMutation>;
export type UpdateSettingMutationOptions = Apollo.BaseMutationOptions<UpdateSettingMutation, UpdateSettingMutationVariables>;
export const AllSettingsDocument = gql`
    query AllSettings {
  allSettings {
    key
    label
    value
    defaultValue
    type
    TTL
    description
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useAllSettingsQuery__
 *
 * To run a query within a React component, call `useAllSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AllSettingsQuery, AllSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSettingsQuery, AllSettingsQueryVariables>(AllSettingsDocument, options);
      }
export function useAllSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSettingsQuery, AllSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSettingsQuery, AllSettingsQueryVariables>(AllSettingsDocument, options);
        }
// @ts-ignore
export function useAllSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllSettingsQuery, AllSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<AllSettingsQuery, AllSettingsQueryVariables>;
export function useAllSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSettingsQuery, AllSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<AllSettingsQuery | undefined, AllSettingsQueryVariables>;
export function useAllSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSettingsQuery, AllSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSettingsQuery, AllSettingsQueryVariables>(AllSettingsDocument, options);
        }
export type AllSettingsQueryHookResult = ReturnType<typeof useAllSettingsQuery>;
export type AllSettingsLazyQueryHookResult = ReturnType<typeof useAllSettingsLazyQuery>;
export type AllSettingsSuspenseQueryHookResult = ReturnType<typeof useAllSettingsSuspenseQuery>;
export type AllSettingsQueryResult = Apollo.QueryResult<AllSettingsQuery, AllSettingsQueryVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($input: CreateUserInput!) {
  createUser(input: $input) {
    _id
    email
    roles
    profile {
      firstName
      lastName
    }
    state
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($_id: ID!, $input: UpdateUserInput!) {
  updateUser(_id: $_id, input: $input) {
    id
    email
    roles
    companyId
    state
    profile {
      firstName
      lastName
      additionalData
    }
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const RegisterUserWithCompanyDocument = gql`
    mutation RegisterUserWithCompany($input: RegisterUserWithCompanyInput!) {
  registerUserWithCompany(input: $input) {
    success
    message
    user {
      _id
      email
      profile {
        firstName
        lastName
      }
      roles
      state
    }
    company {
      id
      companyName
      email
      businessType
      state
    }
  }
}
    `;
export type RegisterUserWithCompanyMutationFn = Apollo.MutationFunction<RegisterUserWithCompanyMutation, RegisterUserWithCompanyMutationVariables>;

/**
 * __useRegisterUserWithCompanyMutation__
 *
 * To run a mutation, you first call `useRegisterUserWithCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserWithCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserWithCompanyMutation, { data, loading, error }] = useRegisterUserWithCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserWithCompanyMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserWithCompanyMutation, RegisterUserWithCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserWithCompanyMutation, RegisterUserWithCompanyMutationVariables>(RegisterUserWithCompanyDocument, options);
      }
export type RegisterUserWithCompanyMutationHookResult = ReturnType<typeof useRegisterUserWithCompanyMutation>;
export type RegisterUserWithCompanyMutationResult = Apollo.MutationResult<RegisterUserWithCompanyMutation>;
export type RegisterUserWithCompanyMutationOptions = Apollo.BaseMutationOptions<RegisterUserWithCompanyMutation, RegisterUserWithCompanyMutationVariables>;
export const AllUsersForCommentsDocument = gql`
    query AllUsersForComments($limit: Int, $offset: Int) {
  allUsers(limit: $limit, offset: $offset) {
    id
    email
    profile {
      firstName
      lastName
      additionalData
    }
    roles
    companyId
    state
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useAllUsersForCommentsQuery__
 *
 * To run a query within a React component, call `useAllUsersForCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersForCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersForCommentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAllUsersForCommentsQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersForCommentsQuery, AllUsersForCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersForCommentsQuery, AllUsersForCommentsQueryVariables>(AllUsersForCommentsDocument, options);
      }
export function useAllUsersForCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersForCommentsQuery, AllUsersForCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersForCommentsQuery, AllUsersForCommentsQueryVariables>(AllUsersForCommentsDocument, options);
        }
// @ts-ignore
export function useAllUsersForCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllUsersForCommentsQuery, AllUsersForCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<AllUsersForCommentsQuery, AllUsersForCommentsQueryVariables>;
export function useAllUsersForCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForCommentsQuery, AllUsersForCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<AllUsersForCommentsQuery | undefined, AllUsersForCommentsQueryVariables>;
export function useAllUsersForCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForCommentsQuery, AllUsersForCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUsersForCommentsQuery, AllUsersForCommentsQueryVariables>(AllUsersForCommentsDocument, options);
        }
export type AllUsersForCommentsQueryHookResult = ReturnType<typeof useAllUsersForCommentsQuery>;
export type AllUsersForCommentsLazyQueryHookResult = ReturnType<typeof useAllUsersForCommentsLazyQuery>;
export type AllUsersForCommentsSuspenseQueryHookResult = ReturnType<typeof useAllUsersForCommentsSuspenseQuery>;
export type AllUsersForCommentsQueryResult = Apollo.QueryResult<AllUsersForCommentsQuery, AllUsersForCommentsQueryVariables>;
export const UserByIdDocument = gql`
    query UserById($id: ID!) {
  userById(id: $id) {
    _id
    email
    roles
    companyId
    profile {
      firstName
      lastName
    }
    state
    lastSeen
    metadata {
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables> & ({ variables: UserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
      }
export function useUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
// @ts-ignore
export function useUserByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<UserByIdQuery, UserByIdQueryVariables>;
export function useUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<UserByIdQuery | undefined, UserByIdQueryVariables>;
export function useUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdSuspenseQueryHookResult = ReturnType<typeof useUserByIdSuspenseQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const UserDirectoryDocument = gql`
    query UserDirectory {
  userDirectory {
    id
    email
    profile {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useUserDirectoryQuery__
 *
 * To run a query within a React component, call `useUserDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDirectoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDirectoryQuery(baseOptions?: Apollo.QueryHookOptions<UserDirectoryQuery, UserDirectoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDirectoryQuery, UserDirectoryQueryVariables>(UserDirectoryDocument, options);
      }
export function useUserDirectoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDirectoryQuery, UserDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDirectoryQuery, UserDirectoryQueryVariables>(UserDirectoryDocument, options);
        }
// @ts-ignore
export function useUserDirectorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserDirectoryQuery, UserDirectoryQueryVariables>): Apollo.UseSuspenseQueryResult<UserDirectoryQuery, UserDirectoryQueryVariables>;
export function useUserDirectorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDirectoryQuery, UserDirectoryQueryVariables>): Apollo.UseSuspenseQueryResult<UserDirectoryQuery | undefined, UserDirectoryQueryVariables>;
export function useUserDirectorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDirectoryQuery, UserDirectoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDirectoryQuery, UserDirectoryQueryVariables>(UserDirectoryDocument, options);
        }
export type UserDirectoryQueryHookResult = ReturnType<typeof useUserDirectoryQuery>;
export type UserDirectoryLazyQueryHookResult = ReturnType<typeof useUserDirectoryLazyQuery>;
export type UserDirectorySuspenseQueryHookResult = ReturnType<typeof useUserDirectorySuspenseQuery>;
export type UserDirectoryQueryResult = Apollo.QueryResult<UserDirectoryQuery, UserDirectoryQueryVariables>;
export const SetWorkflowStateDocument = gql`
    mutation SetWorkflowState($projectId: String!) {
  setWorkflowState(projectId: $projectId) {
    id
    status
    service {
      workflow_version
      current_state
      prev_state
    }
    metadata {
      updatedAt
    }
  }
}
    `;
export type SetWorkflowStateMutationFn = Apollo.MutationFunction<SetWorkflowStateMutation, SetWorkflowStateMutationVariables>;

/**
 * __useSetWorkflowStateMutation__
 *
 * To run a mutation, you first call `useSetWorkflowStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkflowStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkflowStateMutation, { data, loading, error }] = useSetWorkflowStateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSetWorkflowStateMutation(baseOptions?: Apollo.MutationHookOptions<SetWorkflowStateMutation, SetWorkflowStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWorkflowStateMutation, SetWorkflowStateMutationVariables>(SetWorkflowStateDocument, options);
      }
export type SetWorkflowStateMutationHookResult = ReturnType<typeof useSetWorkflowStateMutation>;
export type SetWorkflowStateMutationResult = Apollo.MutationResult<SetWorkflowStateMutation>;
export type SetWorkflowStateMutationOptions = Apollo.BaseMutationOptions<SetWorkflowStateMutation, SetWorkflowStateMutationVariables>;
export const ExecuteWorkflowActionDocument = gql`
    mutation ExecuteWorkflowAction($projectId: String!, $action: String!) {
  executeWorkflowAction(projectId: $projectId, action: $action) {
    id
    status
    service {
      workflow_version
      current_state
      prev_state
    }
    metadata {
      updatedAt
    }
  }
}
    `;
export type ExecuteWorkflowActionMutationFn = Apollo.MutationFunction<ExecuteWorkflowActionMutation, ExecuteWorkflowActionMutationVariables>;

/**
 * __useExecuteWorkflowActionMutation__
 *
 * To run a mutation, you first call `useExecuteWorkflowActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteWorkflowActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeWorkflowActionMutation, { data, loading, error }] = useExecuteWorkflowActionMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useExecuteWorkflowActionMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteWorkflowActionMutation, ExecuteWorkflowActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteWorkflowActionMutation, ExecuteWorkflowActionMutationVariables>(ExecuteWorkflowActionDocument, options);
      }
export type ExecuteWorkflowActionMutationHookResult = ReturnType<typeof useExecuteWorkflowActionMutation>;
export type ExecuteWorkflowActionMutationResult = Apollo.MutationResult<ExecuteWorkflowActionMutation>;
export type ExecuteWorkflowActionMutationOptions = Apollo.BaseMutationOptions<ExecuteWorkflowActionMutation, ExecuteWorkflowActionMutationVariables>;
export const ComputeStageDurationsDocument = gql`
    query ComputeStageDurations($projectId: ID!) {
  computeStageDurations(id: $projectId) {
    projectId
    stages {
      state
      actual_time
      users {
        userId
        userName
        from
        to
      }
    }
  }
}
    `;

/**
 * __useComputeStageDurationsQuery__
 *
 * To run a query within a React component, call `useComputeStageDurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeStageDurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeStageDurationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useComputeStageDurationsQuery(baseOptions: Apollo.QueryHookOptions<ComputeStageDurationsQuery, ComputeStageDurationsQueryVariables> & ({ variables: ComputeStageDurationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComputeStageDurationsQuery, ComputeStageDurationsQueryVariables>(ComputeStageDurationsDocument, options);
      }
export function useComputeStageDurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComputeStageDurationsQuery, ComputeStageDurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComputeStageDurationsQuery, ComputeStageDurationsQueryVariables>(ComputeStageDurationsDocument, options);
        }
// @ts-ignore
export function useComputeStageDurationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComputeStageDurationsQuery, ComputeStageDurationsQueryVariables>): Apollo.UseSuspenseQueryResult<ComputeStageDurationsQuery, ComputeStageDurationsQueryVariables>;
export function useComputeStageDurationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComputeStageDurationsQuery, ComputeStageDurationsQueryVariables>): Apollo.UseSuspenseQueryResult<ComputeStageDurationsQuery | undefined, ComputeStageDurationsQueryVariables>;
export function useComputeStageDurationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComputeStageDurationsQuery, ComputeStageDurationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComputeStageDurationsQuery, ComputeStageDurationsQueryVariables>(ComputeStageDurationsDocument, options);
        }
export type ComputeStageDurationsQueryHookResult = ReturnType<typeof useComputeStageDurationsQuery>;
export type ComputeStageDurationsLazyQueryHookResult = ReturnType<typeof useComputeStageDurationsLazyQuery>;
export type ComputeStageDurationsSuspenseQueryHookResult = ReturnType<typeof useComputeStageDurationsSuspenseQuery>;
export type ComputeStageDurationsQueryResult = Apollo.QueryResult<ComputeStageDurationsQuery, ComputeStageDurationsQueryVariables>;
export const GetWorkflowStagesDocument = gql`
    query GetWorkflowStages($serviceName: String!, $version: Int!) {
  workflowByServiceNameAndVersion(serviceName: $serviceName, version: $version) {
    stages {
      state
      name
      description
      role
      visibility_roles
      comment_required
      estimate_other_stages
      actions {
        name
        state
        comment_required
        branch_by
      }
      estimated_time {
        value
        unit
      }
    }
  }
}
    `;

/**
 * __useGetWorkflowStagesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowStagesQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetWorkflowStagesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowStagesQuery, GetWorkflowStagesQueryVariables> & ({ variables: GetWorkflowStagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowStagesQuery, GetWorkflowStagesQueryVariables>(GetWorkflowStagesDocument, options);
      }
export function useGetWorkflowStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowStagesQuery, GetWorkflowStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowStagesQuery, GetWorkflowStagesQueryVariables>(GetWorkflowStagesDocument, options);
        }
// @ts-ignore
export function useGetWorkflowStagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkflowStagesQuery, GetWorkflowStagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowStagesQuery, GetWorkflowStagesQueryVariables>;
export function useGetWorkflowStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowStagesQuery, GetWorkflowStagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowStagesQuery | undefined, GetWorkflowStagesQueryVariables>;
export function useGetWorkflowStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowStagesQuery, GetWorkflowStagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowStagesQuery, GetWorkflowStagesQueryVariables>(GetWorkflowStagesDocument, options);
        }
export type GetWorkflowStagesQueryHookResult = ReturnType<typeof useGetWorkflowStagesQuery>;
export type GetWorkflowStagesLazyQueryHookResult = ReturnType<typeof useGetWorkflowStagesLazyQuery>;
export type GetWorkflowStagesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowStagesSuspenseQuery>;
export type GetWorkflowStagesQueryResult = Apollo.QueryResult<GetWorkflowStagesQuery, GetWorkflowStagesQueryVariables>;